//
// DO NOT MANUALLY MODIFY THIS FILE: Regenerate with "rake gettext:po2js"
//

/* eslint-disable */
export default {
  "en-CA": {
    "domain": "messages",
    "locale_data": {
      "messages": {
        "": {
          "domain": "messages",
          "plural_forms": "nplurals=2; plural=(n != 1);",
          "lang": "en_CA"
        },
        " of the route": [
          ""
        ],
        "%s EVSE port": [
          "",
          "%s EVSE ports"
        ],
        "%s Selected": [
          ""
        ],
        "%s bar": [
          ""
        ],
        "%s km": [
          ""
        ],
        "%s km from route": [
          ""
        ],
        "%s mi": [
          ""
        ],
        "%s mi from route": [
          ""
        ],
        "%s miles": [
          ""
        ],
        "%s result in": [
          "",
          "%s results in"
        ],
        "%s station along the route": [
          "",
          "%s stations along the route"
        ],
        "%s station location": [
          "",
          "%s station locations"
        ],
        "100 miles between stations": [
          ""
        ],
        "150 miles between stations": [
          ""
        ],
        "200 miles between stations": [
          ""
        ],
        "5 miles from the highway": [
          ""
        ],
        "50 miles between stations": [
          ""
        ],
        "A connector is what is plugged into a vehicle to charge it. Multiple connectors and connector types (such as CHAdeMO and CCS) can be available on one EVSE port, but only one vehicle will charge at a time. Connectors are sometimes called plugs.": [
          ""
        ],
        "A driving route could not be found between your starting and ending locations.": [
          ""
        ],
        "A station location is a site with one or more EVSE ports at the same address. Examples include a parking garage or a mall parking lot.": [
          ""
        ],
        "A valid email address is required.": [
          ""
        ],
        "ACME": [
          ""
        ],
        "About the Alternative Fueling Station Data": [
          "About the Alternative Fuelling Station Data"
        ],
        "About the Data": [
          ""
        ],
        "Access": [
          ""
        ],
        "Access:": [
          ""
        ],
        "Accommodates all vehicle sizes and classes": [
          ""
        ],
        "Accommodates all vehicle sizes and classes.": [
          ""
        ],
        "Accommodates heavy-duty vehicles (Class 6-8).": [
          ""
        ],
        "Accommodates light-duty vehicles only (i.e., passenger vehicles, light-duty pickups, and utility vans)": [
          ""
        ],
        "Accommodates medium-duty vehicles (Class 3-5).": [
          ""
        ],
        "Accommodates passenger vehicles only (Class 1-2).": [
          ""
        ],
        "Accommodates vehicles up to Class 5 (i.e., box trucks and cargo vans)": [
          ""
        ],
        "Address": [
          ""
        ],
        "Address or postal code": [
          ""
        ],
        "Advanced Filters": [
          ""
        ],
        "Advanced filters section of the tool": [
          ""
        ],
        "Agriculture and Agri-Food": [
          ""
        ],
        "Airport": [
          ""
        ],
        "Alberta": [
          ""
        ],
        "All": [
          ""
        ],
        "All Fuels": [
          ""
        ],
        "Alternate Route": [
          ""
        ],
        "Alternative Fuels Station Submission (%s)": [
          ""
        ],
        "An EVSE port provides power to charge only one vehicle at a time even though it may have multiple connectors. The unit that houses EVSE ports is sometimes called a charging post, which can have one or more EVSE ports.": [
          ""
        ],
        "An unexpected error occurred. Please try again or contact us for assistance.": [
          ""
        ],
        "Android App": [
          ""
        ],
        "Arena": [
          ""
        ],
        "As the above networks transition to the OCPI protocol, NRCan works with each to integrate their OCPI-based API. This transition may result in increases to station counts because of the way that station data are shared under the protocol; one station may be split out into several new stations to represent different physical locations of EV chargers at one address (e.g., opposite sides of one parking lot). While the new stations may share the same street address, they may have different coordinates.": [
          ""
        ],
        "As the above networks transition to the OCPI protocol, NREL works with each to integrate their OCPI-based API. This transition may result in increases to station counts because of the way that station data are shared under the protocol; one station may be split out into several new stations to represent different physical locations of EV chargers at one address (e.g., opposite sides of one parking lot). While the new stations may share the same street address, they may have different coordinates.": [
          ""
        ],
        "Auto Repair Shop": [
          ""
        ],
        "Available": [
          ""
        ],
        "Available Fuel(s)": [
          ""
        ],
        "B&B": [
          ""
        ],
        "Bank": [
          ""
        ],
        "Because many public propane stations serve customers other than drivers and fleets, NREL collaborated with propane industry partners to establish and represent the differences. Each public propane station is designated as a \"primary\" or \"secondary\" service type, with both types able to fuel propane vehicles. However, locations with a \"primary\" designation offer vehicle-specific fueling capabilities.": [
          "Because many public propane stations serve customers other than drivers and fleets, NREL collaborated with propane industry partners to establish and represent the differences. Each public propane station is designated as a \"primary\" or \"secondary\" service type, with both types able to fuel propane vehicles. However, locations with a \"primary\" designation offer vehicle-specific fuelling capabilities."
        ],
        "Beginning in 2021, public, non-networked electric vehicle (EV) charging stations will be proactively verified every other year, with half of the EV charging stations verified each year. This adjustment is to accommodate the growing number of EV charging stations in the Station Locator. NRCan will continue to make updates to any station record if changes are reported.": [
          ""
        ],
        "Beginning in 2021, public, non-networked electric vehicle (EV) charging stations will be proactively verified every other year, with half of the EV charging stations verified each year. This adjustment is to accommodate the growing number of EV charging stations in the Station Locator. NREL will continue to make updates to any station record if changes are reported.": [
          ""
        ],
        "Biodiesel": [
          ""
        ],
        "Biodiesel (B20 and above)": [
          ""
        ],
        "Biodiesel Blends Available": [
          ""
        ],
        "Biodiesel Stations": [
          ""
        ],
        "Blends Available:": [
          ""
        ],
        "Both: fast-fill and time-fill": [
          ""
        ],
        "Brewery/Distillery/Winery": [
          ""
        ],
        "British Columbia": [
          ""
        ],
        "Business Hours": [
          ""
        ],
        "CCS": [
          ""
        ],
        "CHAdeMO": [
          ""
        ],
        "CNG": [
          ""
        ],
        "CNG Capacity per Compressor (standard cubic feet per minute)": [
          ""
        ],
        "CNG Dispensers Installed": [
          ""
        ],
        "CNG Fill Pressure (psi)": [
          ""
        ],
        "CNG Fill Type": [
          ""
        ],
        "CNG Renewable Energy Used": [
          ""
        ],
        "CNG Total Storage Capacity (standard cubic feet)": [
          ""
        ],
        "Call ahead": [
          ""
        ],
        "Campground": [
          ""
        ],
        "Canada": [
          ""
        ],
        "Canadian Heritage": [
          ""
        ],
        "Canadian Heritage (Status of Women)": [
          ""
        ],
        "Car Dealer": [
          ""
        ],
        "Card key after hours": [
          ""
        ],
        "Card key at all times": [
          ""
        ],
        "Carwash": [
          ""
        ],
        "Cash": [
          ""
        ],
        "Caution:": [
          ""
        ],
        "Charger Types": [
          ""
        ],
        "Charger types": [
          ""
        ],
        "Charging Infrastructure Terminology": [
          ""
        ],
        "Charging Network:": [
          ""
        ],
        "Check": [
          ""
        ],
        "City": [
          ""
        ],
        "Clear end location": [
          ""
        ],
        "Clear location": [
          ""
        ],
        "Clear start location": [
          ""
        ],
        "Close": [
          ""
        ],
        "Co-Op": [
          ""
        ],
        "College Campus": [
          ""
        ],
        "Comments": [
          ""
        ],
        "Compressed Natural Gas (CNG)": [
          ""
        ],
        "Compressed natural gas stations also list fill type and fill pressure in the details page. These fields are also searchable using the Fuel button on the \"Advanced Filters\" tab.": [
          ""
        ],
        "Connector": [
          ""
        ],
        "Connectors": [
          ""
        ],
        "Connectors:": [
          ""
        ],
        "Convenience Store": [
          ""
        ],
        "Convention Center": [
          ""
        ],
        "Copy and paste this HTML into your website.": [
          ""
        ],
        "Corridor Measurement": [
          ""
        ],
        "Country": [
          ""
        ],
        "Credit": [
          ""
        ],
        "Credit Card": [
          ""
        ],
        "Credit card after hours": [
          ""
        ],
        "Credit card at all times": [
          ""
        ],
        "Criteria for Corridors": [
          ""
        ],
        "DC Fast": [
          ""
        ],
        "DC fast charging available": [
          ""
        ],
        "Data Collection Methods": [
          ""
        ],
        "Data for this station comes from the %s network. You can use this form to suggest updates, but we also recommend that you <a href='%s'>contact the network</a> directly to report changes because we cannot edit station information for this network.": [
          ""
        ],
        "Debit": [
          ""
        ],
        "Debit Card": [
          ""
        ],
        "Developer API": [
          ""
        ],
        "Developer APIs": [
          ""
        ],
        "Diagram of an electric vehicle charging station showing how one station can have multiple EVSE ports and each EVSE port can have one or more connectors": [
          ""
        ],
        "Directions": [
          ""
        ],
        "Distance from the Route to Show Stations": [
          ""
        ],
        "Download Data": [
          ""
        ],
        "Download Results": [
          ""
        ],
        "Download list of stations on route": [
          ""
        ],
        "Duplicate": [
          ""
        ],
        "E15": [
          ""
        ],
        "E20-E25": [
          ""
        ],
        "E30-E35": [
          ""
        ],
        "E40 and above": [
          ""
        ],
        "EV Charging Stations": [
          ""
        ],
        "EVSE Port": [
          ""
        ],
        "EVSE Ports": [
          ""
        ],
        "Each point on the map is counted as one station in the station count. A station appears as one point on the map, regardless of the number of fuel dispensers or electric vehicle supply equipment (EVSE) ports at that location. Station addresses are geocoded and mapped using an automatic geocoding application. The geocoding application returns the most accurate location based on the provided address. Station locations may also be provided by external sources (e.g., station operators) and/or verified in a geographic information system (GIS) tool. This information is considered highly accurate, and these coordinates override any information generated using the geocoding application.": [
          ""
        ],
        "Each point on the map is counted as one station in the station count. The number of EVSE ports and types of connectors available at each station location are displayed in the details page for each station location. Users may search by charger types, connectors, and networks using the Fuel button on the \"Advanced Filters\" tab.": [
          ""
        ],
        "Edit Filters": [
          ""
        ],
        "Electric": [
          ""
        ],
        "Electric Charging Manufacturer": [
          ""
        ],
        "Electric Charging Network": [
          ""
        ],
        "Electric Charging Power (kW)": [
          ""
        ],
        "Electric Charging Pricing": [
          ""
        ],
        "Electric Charging Renewable Energy Used": [
          ""
        ],
        "Electric Vehicle Charging": [
          ""
        ],
        "Email": [
          ""
        ],
        "Embed Tool": [
          ""
        ],
        "Embed the Alternative Fueling Station Locator": [
          "Embed the Alternative Fuelling Station Locator"
        ],
        "Embed the station locator using the results you are currently viewing as the default.": [
          ""
        ],
        "Employment, Workforce Development and Labour": [
          ""
        ],
        "End location": [
          ""
        ],
        "Enter an address or postal code": [
          ""
        ],
        "Enter location": [
          ""
        ],
        "Environment and Climate Change": [
          ""
        ],
        "Ethanol": [
          ""
        ],
        "Ethanol (E85)": [
          ""
        ],
        "Ethanol (E85) Stations": [
          ""
        ],
        "Ethanol Other Blends Offered": [
          ""
        ],
        "Existing": [
          ""
        ],
        "Existing stations in the database are contacted at least once a year on an established schedule to verify they are still operational and providing the fuel specified. Based on an established data collection schedule, the database is updated on an ongoing basis. Stations that are no longer operational or no longer provide alternative fuel are removed from the database as they are identified.": [
          ""
        ],
        "Expected Open/Reopen Date": [
          ""
        ],
        "Factory": [
          ""
        ],
        "Families, Children and Social Development": [
          ""
        ],
        "Fast-fill": [
          ""
        ],
        "Fast-fill and time-fill": [
          ""
        ],
        "Federal Government": [
          ""
        ],
        "Federal Government Owned": [
          ""
        ],
        "Fill Pressure:": [
          ""
        ],
        "Fill Type:": [
          ""
        ],
        "Fill pressure": [
          ""
        ],
        "Fill type": [
          ""
        ],
        "Filter by Fuel Type": [
          ""
        ],
        "Filter by Location": [
          ""
        ],
        "Filter by Station Details": [
          ""
        ],
        "Filters chosen:": [
          ""
        ],
        "Finance": [
          ""
        ],
        "Find Stations": [
          ""
        ],
        "Fire Station": [
          ""
        ],
        "First Name": [
          ""
        ],
        "Fisheries, Oceans and the Canadian Coast Guard": [
          ""
        ],
        "Fleet Card": [
          ""
        ],
        "Fleet Garage": [
          ""
        ],
        "Fleet customers only": [
          ""
        ],
        "For more information about the data, contact the <a href='%s'>webmaster</a> or refer to the <a href='%s'>list of data fields</a>.": [
          ""
        ],
        "For more information about the data, contact the <a href='%s'>webmaster</a>.": [
          ""
        ],
        "Fuel": [
          ""
        ],
        "Fuel Corridors": [
          ""
        ],
        "Fuel Reseller": [
          ""
        ],
        "Fuel cell electric vehicle drivers have access to hydrogen stations in certain areas of the country. Because this technology is in the early commercialization stages, the status of hydrogen fueling stations may change more frequently than other fuel types. To allow users to monitor station status more closely, hydrogen stations now indicate whether or not they have reduced fueling capacity.": [
          "Fuel cell electric vehicle drivers have access to hydrogen stations in certain areas of the country. Because this technology is in the early commercialization stages, the status of hydrogen fuelling stations may change more frequently than other fuel types. To allow users to monitor station status more closely, hydrogen stations now indicate whether or not they have reduced fuelling capacity."
        ],
        "Fuel cell electric vehicle drivers may have access to hydrogen stations in certain areas of the country. Because this technology is in the early commercialization stages, the status of hydrogen fueling stations may change more frequently than other fuel types. To allow users to monitor station status more closely, hydrogen stations now indicate whether or not they have reduced fueling capacity.": [
          "Fuel cell electric vehicle drivers may have access to hydrogen stations in certain areas of the country. Because this technology is in the early commercialization stages, the status of hydrogen fuelling stations may change more frequently than other fuel types. To allow users to monitor station status more closely, hydrogen stations now indicate whether or not they have reduced fuelling capacity."
        ],
        "GPS": [
          ""
        ],
        "General comments": [
          ""
        ],
        "Geothermal": [
          ""
        ],
        "Global Affairs (Foreign Affairs)": [
          ""
        ],
        "Global Affairs (International Development)": [
          ""
        ],
        "Global Affairs (International Trade)": [
          ""
        ],
        "Government only": [
          ""
        ],
        "Grocery Store": [
          ""
        ],
        "HTML": [
          ""
        ],
        "Hardware Store": [
          ""
        ],
        "Health": [
          ""
        ],
        "Heavy-duty (Class 6-8)": [
          ""
        ],
        "Heavy-duty (class 6-8)": [
          ""
        ],
        "Help": [
          ""
        ],
        "Hospital": [
          ""
        ],
        "Hotel": [
          ""
        ],
        "Hydrogen": [
          ""
        ],
        "Hydrogen Pressure": [
          ""
        ],
        "Hydrogen SAE Standards Compliance": [
          ""
        ],
        "Hydrogen Stations": [
          ""
        ],
        "Hydropower": [
          ""
        ],
        "If you have more than one station to add or update, contact the <a href='%s'>Technical Response Service</a> for a spreadsheet.": [
          ""
        ],
        "Immigration, Refugees and Citizenship": [
          ""
        ],
        "In addition to marking the station as out of service on this form, please report any broken equipment or access issues to the station owner.": [
          ""
        ],
        "Include non-retail stations": [
          ""
        ],
        "Include only stations offering mid-level blends": [
          ""
        ],
        "Include stations with limited vehicle fueling": [
          "Include stations with limited vehicle fuelling"
        ],
        "Include stations with limited vehicle fueling capabilities": [
          "Include stations with limited vehicle fuelling capabilities"
        ],
        "Includes non-retail stations": [
          ""
        ],
        "Includes stations with limited vehicle-specific fueling capabilities": [
          "Includes stations with limited vehicle-specific fuelling capabilities"
        ],
        "Indicate when the station went out of service and why it closed": [
          ""
        ],
        "Indigenous and Northern Affairs": [
          ""
        ],
        "Infrastructure and Communities": [
          ""
        ],
        "Inn": [
          ""
        ],
        "Innovation, Science and Economic Development": [
          ""
        ],
        "J1772": [
          ""
        ],
        "J2601": [
          ""
        ],
        "J2601-2": [
          ""
        ],
        "Jointly Owned": [
          ""
        ],
        "Justice": [
          ""
        ],
        "LNG": [
          ""
        ],
        "LNG Renewable Energy Used": [
          ""
        ],
        "Landfill": [
          ""
        ],
        "Last Name": [
          ""
        ],
        "Last confirmed: %s": [
          ""
        ],
        "Latitude": [
          ""
        ],
        "Leader of the Government in the House of Commons": [
          ""
        ],
        "Learn about the station location data collection methods, update schedules, and station details.": [
          ""
        ],
        "Legacy chargers": [
          ""
        ],
        "Legend": [
          ""
        ],
        "Level 1": [
          ""
        ],
        "Level 1 charging is a 120V standard wall plug using a J1772 connector. Provides 2 to 5 miles of range per 1 hour of charging.": [
          ""
        ],
        "Level 1 charging is a 120V standard wall plug using a J1772 connector. Provides 3 to 8 kilometers of range per 1 hour of charging.": [
          ""
        ],
        "Level 1 electric vehicle charging available": [
          ""
        ],
        "Level 2": [
          ""
        ],
        "Level 2 charging uses 240V/208V for residential or commercial charging using a J1772 connector. Provides 10 to 20 miles of range per 1 hour of charging.": [
          ""
        ],
        "Level 2 charging uses 240V/208V for residential or commercial charging using a J1772 connector. Provides 16 to 32 kilometers of range per 1 hour of charging.": [
          ""
        ],
        "Level 2 electric vehicle charging available": [
          ""
        ],
        "Level 3": [
          ""
        ],
        "Library": [
          ""
        ],
        "Limit results to within": [
          ""
        ],
        "Limited hours": [
          ""
        ],
        "Liquefied Natural Gas (LNG)": [
          ""
        ],
        "Livestock Operations": [
          ""
        ],
        "Local/Municipal Government Owned": [
          ""
        ],
        "Location": [
          ""
        ],
        "Longitude": [
          ""
        ],
        "Manitoba": [
          ""
        ],
        "Many public propane stations serve customers other than drivers and fleets. To represent the differences, each public propane station is designated as a \"primary\" or \"secondary\" service type, with both types able to fuel propane vehicles. However, locations with a \"primary\" designation offer vehicle-specific fueling capabilities.": [
          "Many public propane stations serve customers other than drivers and fleets. To represent the differences, each public propane station is designated as a \"primary\" or \"secondary\" service type, with both types able to fuel propane vehicles. However, locations with a \"primary\" designation offer vehicle-specific fuelling capabilities."
        ],
        "Map Results": [
          ""
        ],
        "Map a Route": [
          ""
        ],
        "Mapping and Counting Methods": [
          ""
        ],
        "Medium-duty (Class 3-5)": [
          ""
        ],
        "Medium-duty (class 3-5)": [
          ""
        ],
        "Mid-Level Blends:": [
          ""
        ],
        "Military Base": [
          ""
        ],
        "More": [
          ""
        ],
        "More Information": [
          ""
        ],
        "Motor Pool": [
          ""
        ],
        "Multi-Family Housing": [
          ""
        ],
        "Municipal Government": [
          ""
        ],
        "Museum": [
          ""
        ],
        "NEMA 14-50": [
          ""
        ],
        "NEMA 5-15": [
          ""
        ],
        "NEMA 5-20": [
          ""
        ],
        "NRCan collects and publishes data on planned station locations, particularly those that are sited and have begun the installation process. In addition, the Station Locator includes stations that are temporarily out of service or offline with plans to open again in the future. To include planned and temporarily unavailable stations in the search results, use the \"Advanced Filters\" tab.": [
          ""
        ],
        "NRCan is in the process of transitioning EV charging station counting logic to align with the hierarchy defined in the Open Charge Point Interface (OCPI) protocol: station location, EVSE port, and connector. With this transition, NRCan is updating the number of EVSE ports (formerly called charging outlets) in the Stations Locator, which represents the number of vehicles that can charge simultaneously at a station location. The Station Locator also identifies the available connector types. Both the total number of station locations and EVSE ports appear in the EV charging search results on the \"Advanced Filters\" tab.": [
          ""
        ],
        "NRCan recommends users verify a station is open, available to the public, and has the desired alternative fuel prior to making a trip to that location.": [
          ""
        ],
        "NRCan regularly compares its station data with those of other relevant trade organizations and websites. Differences in methodologies, data confirmation, and inclusion criteria may result in slight variations between NRCan's database and those maintained by other organizations. NRCan also collaborates with alternative fuel industry groups to identify discrepancies in data and develop data sharing processes and best practices. NRCan and its data collection subcontractor are currently collaborating with alternative fuel industry groups to ensure best practices are being followed for identifying new stations and confirming station changes in the most-timely manner possible.": [
          ""
        ],
        "NREL collaborated with industry groups to revisit the definition of public hydrogen stations and refined the Station Locator data to differentiate between stations that are only available to a certain subset of customers (e.g., require an access card, PIN, or training) and those that are considered retail locations (e.g., accept payment at the point of sale). Access designations are available in the details page for each public station. The Station Locator defaults to showing only public retail stations. Users may expand their search to include all public hydrogen stations by selecting the \"Include non-retail stations\" checkbox.": [
          ""
        ],
        "NREL collects and publishes data on planned station locations, particularly those that are sited and have begun the installation process. In addition, the Station Locator includes stations that are temporarily out of service or offline with plans to open again in the future. To include planned and temporarily unavailable stations in the search results, use the \"Advanced Filters\" tab.": [
          ""
        ],
        "NREL is in the process of transitioning EV charging station counting logic to align with the hierarchy defined in the Open Charge Point Interface (OCPI) protocol: station location, EVSE port, and connector. With this transition, NREL is updating the number of EVSE ports (formerly called charging outlets) in the Stations Locator, which represents the number of vehicles that can charge simultaneously at a station location. The Station Locator also identifies the available connector types. Both the total number of station locations and EVSE ports appear in the EV charging search results on the \"Advanced Filters\" tab.": [
          ""
        ],
        "NREL regularly compares its station data with those of other relevant trade organizations and websites. Differences in methodologies, data confirmation, and inclusion criteria may result in slight variations between NREL's database and those maintained by other organizations. NREL also collaborates with alternative fuel industry groups to identify discrepancies in data and develop data sharing processes and best practices. NREL and its data collection subcontractor are currently collaborating with natural gas, electric drive, biodiesel, ethanol, hydrogen, and propane industry groups to ensure best practices are being followed for identifying new stations and confirming station changes in the most-timely manner possible.": [
          ""
        ],
        "National Defence": [
          ""
        ],
        "National Park": [
          ""
        ],
        "National Revenue": [
          ""
        ],
        "Natural Gas Stations": [
          ""
        ],
        "Natural Resources": [
          ""
        ],
        "Natural Resources Canada": [
          ""
        ],
        "Networks": [
          ""
        ],
        "Networks:": [
          ""
        ],
        "New Brunswick": [
          ""
        ],
        "Newfoundland and Labrador": [
          ""
        ],
        "Next": [
          ""
        ],
        "No": [
          ""
        ],
        "Non-Networked": [
          ""
        ],
        "None": [
          ""
        ],
        "Northwest Territories": [
          ""
        ],
        "Note that several states, including Alabama, Indiana, Kansas, Missouri, and Oklahoma, require or allow in-state propane vehicles to obtain a decal in lieu of paying state fuel taxes at the pump. Out-of-state vehicles may still be subject to taxes at the pump. Determinations about price differential (for the purposes of the primary or secondary propane station designation) are made assuming that the vehicle has an in-state decal. For more information about state decals and similar laws and regulations, visit the <a href='%s'>AFDC Laws & Incentives</a> database.": [
          ""
        ],
        "Notes about Specific Station Types": [
          ""
        ],
        "Nova Scotia": [
          ""
        ],
        "Number of DC Fast Ports": [
          ""
        ],
        "Number of Level 1 Ports": [
          ""
        ],
        "Number of Level 2 Ports": [
          ""
        ],
        "Nunavut": [
          ""
        ],
        "Office Building": [
          ""
        ],
        "Only DC fast charging stations with CHAdeMO and CCS connectors (no Tesla)": [
          ""
        ],
        "Only fast-fill stations with 3,600 psi fill pressure": [
          ""
        ],
        "Only primary stations (offer fueling capabilities for vehicles)": [
          "Only primary stations (offer fuelling capabilities for vehicles)"
        ],
        "Only public stations": [
          ""
        ],
        "Only retail stations (accept payment at the point of sale)": [
          ""
        ],
        "Only stations with mid-level blends": [
          ""
        ],
        "Ontario": [
          ""
        ],
        "Open Date": [
          ""
        ],
        "Optional Fuel Information": [
          ""
        ],
        "Optional Station Information": [
          ""
        ],
        "Other": [
          ""
        ],
        "Other Blends Offered:": [
          ""
        ],
        "Other Entertainment": [
          ""
        ],
        "Out of Service": [
          ""
        ],
        "Owner": [
          ""
        ],
        "Owner:": [
          ""
        ],
        "PLANNED - not yet accessible": [
          ""
        ],
        "Page": [
          ""
        ],
        "Park": [
          ""
        ],
        "Parking Garage": [
          ""
        ],
        "Parking Lot": [
          ""
        ],
        "Parliament": [
          ""
        ],
        "Passenger vehicles (Class 1-2)": [
          ""
        ],
        "Passenger vehicles (class 1-2)": [
          ""
        ],
        "Pay-Parking Garage": [
          ""
        ],
        "Pay-Parking Lot": [
          ""
        ],
        "Payment": [
          ""
        ],
        "Payment Types": [
          ""
        ],
        "Payment:": [
          ""
        ],
        "Pending Corridor": [
          ""
        ],
        "Pharmacy": [
          ""
        ],
        "Phone": [
          ""
        ],
        "Place of Worship": [
          ""
        ],
        "Plan Cancelled": [
          ""
        ],
        "Planned": [
          ""
        ],
        "Planned and Temporarily Unavailable Stations": [
          ""
        ],
        "Please Note:": [
          ""
        ],
        "Postal Code": [
          ""
        ],
        "President of the Queen's Privy Council for Canada": [
          ""
        ],
        "Pressure Available:": [
          ""
        ],
        "Prev": [
          ""
        ],
        "Prime Minister": [
          ""
        ],
        "Prince Edward Island": [
          ""
        ],
        "Prison": [
          ""
        ],
        "Private": [
          ""
        ],
        "Private Stations": [
          ""
        ],
        "Privately Owned": [
          ""
        ],
        "Propane": [
          ""
        ],
        "Propane (LPG)": [
          ""
        ],
        "Propane (Liquefied Petroleum Gas [LPG])": [
          ""
        ],
        "Propane (Liquefied Petroleum Gas, LPG) Stations": [
          ""
        ],
        "Propane Nozzles": [
          ""
        ],
        "Propane Nozzles:": [
          ""
        ],
        "Province/Territory": [
          ""
        ],
        "Provincial Government Owned": [
          ""
        ],
        "Public": [
          ""
        ],
        "Public Safety and Emergency Preparedness": [
          ""
        ],
        "Public Services and Procurement": [
          ""
        ],
        "Public Stations": [
          ""
        ],
        "Public locations with the \"primary\" designation must be staffed during regular business hours and must not require drivers to call ahead in order to fuel. Primary stations must also accept credit cards or fleet cards as a payment type. To be considered \"primary,\" the station must be able to fuel vehicles at a rate of 30-45 litres (8-12 gallons) per minute or faster, or at a rate similar to filling a gasoline vehicle.": [
          ""
        ],
        "Public locations with the \"primary\" designation must be staffed during regular business hours and must not require drivers to call ahead in order to fuel. Primary stations must also accept credit cards or fleet cards as a payment type. To be considered \"primary,\" the station must be able to fuel vehicles at a rate of 8-12 gallons per minute or faster, or at a rate similar to filling a gasoline vehicle.": [
          ""
        ],
        "Quebec": [
          ""
        ],
        "Quick-connect": [
          ""
        ],
        "RV Park": [
          ""
        ],
        "Ready Corridor": [
          ""
        ],
        "Recreational Sports Facility": [
          ""
        ],
        "Refinery": [
          ""
        ],
        "Rental Car Return": [
          ""
        ],
        "Report a Change": [
          ""
        ],
        "Report a change": [
          ""
        ],
        "Required": [
          ""
        ],
        "Required field": [
          ""
        ],
        "Research Facility/Laboratory": [
          ""
        ],
        "Residential": [
          ""
        ],
        "Residential EV charging locations and \"wall outlets\" not designated for vehicle charging are not included in the Station Locator, but workplace charging locations are.": [
          ""
        ],
        "Rest Stop": [
          ""
        ],
        "Restaurant": [
          ""
        ],
        "Retail": [
          ""
        ],
        "SAE": [
          ""
        ],
        "SAE CCS": [
          ""
        ],
        "SAE Standards Compliance:": [
          ""
        ],
        "Saskatchewan": [
          ""
        ],
        "School": [
          ""
        ],
        "Science": [
          ""
        ],
        "Search": [
          ""
        ],
        "Selected Route": [
          ""
        ],
        "Service designations are available in the details page for each public station. The Station Locator defaults to showing only public \"primary\" stations. Users may expand their search to include all propane stations by using the \"Include stations with limited vehicle fueling\" checkbox after choosing propane as a fuel or select this same option in the \"Advanced Filters\" tab.": [
          "Service designations are available in the details page for each public station. The Station Locator defaults to showing only public \"primary\" stations. Users may expand their search to include all propane stations by using the \"Include stations with limited vehicle fuelling\" checkbox after choosing propane as a fuel or select this same option in the \"Advanced Filters\" tab."
        ],
        "Service/Gas Station": [
          ""
        ],
        "Shopping Center": [
          ""
        ],
        "Shopping Mall": [
          ""
        ],
        "Show stations within": [
          ""
        ],
        "Small Business and Tourism": [
          ""
        ],
        "Solar": [
          ""
        ],
        "Some compressed and liquefied natural gas stations are not able to fuel larger vehicles due to access limitations, such as a low canopy, insufficient parking adjacent to the pump, or limited space to maneuver. Natural gas station details include vehicle accessibility information, specifically the vehicle classes that can physically access the fueling infrastructure. Please note, this field does not take into account station capacity, throughput, or other considerations. Options include:": [
          "Some compressed and liquefied natural gas stations are not able to fuel larger vehicles due to access limitations, such as a low canopy, insufficient parking adjacent to the pump, or limited space to maneuver. Natural gas station details include vehicle accessibility information, specifically the vehicle classes that can physically access the fuelling infrastructure. Please note, this field does not take into account station capacity, throughput, or other considerations. Options include:"
        ],
        "Source:": [
          ""
        ],
        "Specific Address": [
          ""
        ],
        "Specific station details": [
          ""
        ],
        "Stadium": [
          ""
        ],
        "Standalone Station": [
          ""
        ],
        "Start location": [
          ""
        ],
        "State": [
          ""
        ],
        "State Government Owned": [
          ""
        ],
        "State/Province/Territory": [
          ""
        ],
        "State/Provincial Government": [
          ""
        ],
        "State/Provincial Government Owned": [
          ""
        ],
        "State/Territory": [
          ""
        ],
        "Station": [
          ""
        ],
        "Station Information": [
          ""
        ],
        "Station Location": [
          ""
        ],
        "Station Name": [
          ""
        ],
        "Station Phone": [
          ""
        ],
        "Station Update Schedule": [
          ""
        ],
        "Station details are subject to change. We recommend calling the station to verify location, hours of operation, and access.": [
          ""
        ],
        "Station status": [
          ""
        ],
        "Stations with an access listing of \"Private - Fleet customers only\" may allow other entities to fuel through a business-to-business arrangement. For more information, fleet customers should refer to the information listed in the details section for that station and contact the station directly.": [
          ""
        ],
        "Status": [
          ""
        ],
        "Status:": [
          ""
        ],
        "Storage Facility": [
          ""
        ],
        "Street Parking": [
          ""
        ],
        "Submit": [
          ""
        ],
        "Submit New Station": [
          ""
        ],
        "TEMPORARILY UNAVAILABLE": [
          ""
        ],
        "Temporarily Unavailable": [
          ""
        ],
        "Tesla": [
          ""
        ],
        "Thank you for your station submission. Please note that your update will not automatically appear in the Alternative Fueling Station Locator. All station information must be confirmed before changes are made. The turn-around time for updates will depend on the completeness of the information provided as well as the responsiveness of the station or point of contact.": [
          "Thank you for your station submission. Please note that your update will not automatically appear in the Alternative Fuelling Station Locator. All station information must be confirmed before changes are made. The turn-around time for updates will depend on the completeness of the information provided as well as the responsiveness of the station or point of contact."
        ],
        "Thank you for your station submission. Please note that your update will not automatically appear in the Alternative Fueling Station Locator. All station information must be confirmed before changes are made. The turn-around time for updates will depend on the completeness of the information provided as well as the responsiveness of the station or point of contact. We will contact you directly if we have any questions about your submission.": [
          "Thank you for your station submission. Please note that your update will not automatically appear in the Alternative Fuelling Station Locator. All station information must be confirmed before changes are made. The turn-around time for updates will depend on the completeness of the information provided as well as the responsiveness of the station or point of contact. We will contact you directly if we have any questions about your submission."
        ],
        "The AFDC recommends users verify a station is open, available to the public, and has the desired alternative fuel prior to making a trip to that location.": [
          ""
        ],
        "The Alternative Fueling Station Locator uses the following charging infrastructure definitions:": [
          "The Alternative Fuelling Station Locator uses the following charging infrastructure definitions:"
        ],
        "The Station Locator Team": [
          ""
        ],
        "The Station Locator data differentiates between public hydrogen stations that are only available to a certain subset of customers (e.g., require an access card, PIN, or training) and those that are considered retail locations (e.g., accept payment at the point of sale). Access designations are available in the details page for each public station. The Station Locator defaults to showing only public retail stations. Users may expand their search to include all public hydrogen stations by selecting the \"Include non-retail stations\" checkbox.": [
          ""
        ],
        "The Station Locator defaults to searching only for public stations. To include private stations in the search, use the Station button on the \"Advanced Filters\" tab.": [
          ""
        ],
        "The Station Locator imports Blink, ChargePoint, Electrify America, EVgo, FLO, Greenlots, OpConnect, SemaConnect, and Webasto network station data directly from these networks on a daily basis. Please note there may be variations in the formatting of API stations from other alternative fuels in the Station Locator. Also note, NREL cannot edit station information for the networks listed above. To suggest edits to these stations, please contact the charging network directly with the recommended changes. For network contact information, please contact the webmaster listed in the \"More Information\" section below.": [
          ""
        ],
        "The Station Locator imports ChargePoint, Circuit électrique, FLO, Greenlots, and SemaConnect network station data directly from these networks on a daily basis. Please note there may be variations in the formatting of API stations from other alternative fuels in the Station Locator. Also note, NRCan cannot edit station information for the networks listed above. To suggest edits to these stations, please contact the charging network directly with the recommended changes. For network contact information, please contact the webmaster listed in the \"More Information\" section below.": [
          ""
        ],
        "The Station Locator includes information on private fleet fueling stations (e.g., transit bus fueling facilities, other medium- and heavy-duty fueling and charging infrastructure) and workplace charging stations. Note that information on these stations is not always published online or in the data download but may be tracked only in the backend Station Locator database. Information tracked only in the backend database may be provided by request to the webmaster listed in the \"More Information\" section below.": [
          "The Station Locator includes information on private fleet fuelling stations (e.g., transit bus fuelling facilities, other medium- and heavy-duty fuelling and charging infrastructure) and workplace charging stations. Note that information on these stations is not always published online or in the data download but may be tracked only in the backend Station Locator database. Information tracked only in the backend database may be provided by request to the webmaster listed in the \"More Information\" section below."
        ],
        "The Station Locator includes information on private fleet fueling stations (e.g., transit bus fueling facilities, other medium- and heavy-duty fueling and charging infrastructure), workplace charging stations, and multi-family housing charging stations. Note that information on these stations is not always published online or in the data download but may be tracked only in the backend Station Locator database. Information tracked only in the backend database may be provided by request to the webmaster listed in the \"More Information\" section below.": [
          "The Station Locator includes information on private fleet fuelling stations (e.g., transit bus fuelling facilities, other medium- and heavy-duty fuelling and charging infrastructure), workplace charging stations, and multi-family housing charging stations. Note that information on these stations is not always published online or in the data download but may be tracked only in the backend Station Locator database. Information tracked only in the backend database may be provided by request to the webmaster listed in the \"More Information\" section below."
        ],
        "The Station Locator includes stations offering high-level ethanol-gasoline blends (E85). Users may limit their search to E85 stations offering mid-level blends, such as E30, by using the Fuel button on the \"Advanced Filters\" tab.": [
          ""
        ],
        "The Station Locator only includes stations offering biodiesel blends of 20% (B20) and above for a certain period of time during the year. The available blends at each station location are displayed when the station location is selected.": [
          ""
        ],
        "The data in the Alternative Fueling Station Locator are gathered and verified through a variety of methods. National Resources Canada (NRCan) obtains information about new stations from trade media, the Submit New Station form on the Station Locator website, and through collaborating with infrastructure equipment and fuel providers, original equipment manufacturers (OEMs), and industry groups.": [
          "The data in the Alternative Fuelling Station Locator are gathered and verified through a variety of methods. National Resources Canada (NRCan) obtains information about new stations from trade media, the Submit New Station form on the Station Locator website, and through collaborating with infrastructure equipment and fuel providers, original equipment manufacturers (OEMs), and industry groups."
        ],
        "The data in the Alternative Fueling Station Locator are gathered and verified through a variety of methods. The National Renewable Energy Laboratory (NREL) obtains information about new stations from trade media, Clean Cities coordinators, the Submit New Station form on the Station Locator website, and through collaborating with infrastructure equipment and fuel providers, original equipment manufacturers (OEMs), and industry groups.": [
          "The data in the Alternative Fuelling Station Locator are gathered and verified through a variety of methods. The National Renewable Energy Laboratory (NREL) obtains information about new stations from trade media, Clean Cities coordinators, the Submit New Station form on the Station Locator website, and through collaborating with infrastructure equipment and fuel providers, original equipment manufacturers (OEMs), and industry groups."
        ],
        "The location could not be found. Please try another location.": [
          ""
        ],
        "The station could not be found. Please try searching for another station.": [
          ""
        ],
        "There are no stations along the route that match your filters.": [
          ""
        ],
        "There are no stations that match your filters.": [
          ""
        ],
        "There are three types of DC fast charging systems depending on the type of charge port on the vehicle. Provides 60 to 80 miles of range per 20 minutes of charging.": [
          ""
        ],
        "There are three types of DC fast charging systems depending on the type of charge port on the vehicle. Provides 95 to 130 kilometers of range per 20 minutes of charging.": [
          ""
        ],
        "These stations are only available to a certain subset of customers.": [
          ""
        ],
        "These stations have fuel available for use in vehicles but limited vehicle fueling services.": [
          "These stations have fuel available for use in vehicles but limited vehicle fuelling services."
        ],
        "This field is required.": [
          ""
        ],
        "This form cannot be submitted. See the errors marked below.": [
          ""
        ],
        "This station has fuel for vehicles and vehicle-specific fueling services that are consistently offered during business hours.": [
          "This station has fuel for vehicles and vehicle-specific fuelling services that are consistently offered during business hours."
        ],
        "This station has fuel for vehicles but limited availability and/or limited vehicle-specific fueling capabilities.": [
          "This station has fuel for vehicles but limited availability and/or limited vehicle-specific fuelling capabilities."
        ],
        "This station is available to all customers and is considered a retail location.": [
          ""
        ],
        "This station is only available to a certain subset of customers and is considered a non-retail location.": [
          ""
        ],
        "Time-fill": [
          ""
        ],
        "Transport": [
          ""
        ],
        "Transportation Network Company": [
          ""
        ],
        "Travel Center": [
          ""
        ],
        "Treasury Board": [
          ""
        ],
        "Truck Stop": [
          ""
        ],
        "Type": [
          ""
        ],
        "Type of Access": [
          ""
        ],
        "Types:": [
          ""
        ],
        "U.S. and Canada": [
          ""
        ],
        "Unavailable": [
          ""
        ],
        "United States": [
          ""
        ],
        "Unknown": [
          ""
        ],
        "Use this form to suggest adding a station.": [
          ""
        ],
        "Use this form to suggest updates for the station.": [
          ""
        ],
        "Users submitting updates through the \"Submit New Station\" or \"Report a Change\" forms will receive an email confirmation of their submittal. NRCan will verify station details before the station is added or updated in the Station Locator. The turnaround time for updates will depend on the completeness of the information provided, as well as the responsiveness of the station or point of contact.": [
          ""
        ],
        "Users submitting updates through the \"Submit New Station\" or \"Report a Change\" forms will receive an email confirmation of their submittal. NREL will verify station details before the station is added or updated in the Station Locator. The turnaround time for updates will depend on the completeness of the information provided, as well as the responsiveness of the station or point of contact.": [
          ""
        ],
        "Utility": [
          ""
        ],
        "Utility Owned": [
          ""
        ],
        "Vehicle Accessibility:": [
          ""
        ],
        "Vehicle accessibility": [
          ""
        ],
        "Veterans Affairs": [
          ""
        ],
        "Wastewater Treatment": [
          ""
        ],
        "We will contact you directly if we have any questions about your submission.": [
          ""
        ],
        "What feedback would you like to provide?": [
          ""
        ],
        "Wind": [
          ""
        ],
        "Within %s km of:": [
          ""
        ],
        "Within %s mi of:": [
          ""
        ],
        "Workplace": [
          ""
        ],
        "Yes": [
          ""
        ],
        "You can download the station data using:": [
          ""
        ],
        "Your Contact Information": [
          ""
        ],
        "Your browser is not compatible with this application. Please update your browser to the latest version or <a href=\"%s\">contact us</a> for assistance.": [
          ""
        ],
        "Your search exceeds the maximum distance of 100 miles from the route. Please enter a shorter distance.": [
          ""
        ],
        "Your search exceeds the maximum distance of 160 kilometers from the route. Please enter a shorter distance.": [
          ""
        ],
        "Your search exceeds the maximum radius of 500 miles from the location. Please enter a smaller radius.": [
          ""
        ],
        "Your search exceeds the maximum radius of 804 kilometers from the location. Please enter a smaller radius.": [
          ""
        ],
        "Yukon": [
          ""
        ],
        "bar": [
          ""
        ],
        "clear all filters": [
          ""
        ],
        "for U.S. stations": [
          ""
        ],
        "iPhone App": [
          ""
        ],
        "km": [
          ""
        ],
        "miles": [
          ""
        ],
        "access|\u0004Private": [
          ""
        ],
        "access|\u0004Public": [
          ""
        ],
        "access|\u0004Public & private": [
          ""
        ]
      }
    }
  },
  "fr-CA": {
    "domain": "messages",
    "locale_data": {
      "messages": {
        "": {
          "domain": "messages",
          "lang": ""
        },
        " of the route": [
          "du trajet"
        ],
        "%s EVSE port": [
          "%s port d’EAVE",
          "%s ports d’EAVE"
        ],
        "%s Selected": [
          "%s sélectionné"
        ],
        "%s bar": [
          "%s bar"
        ],
        "%s km": [
          "%s km"
        ],
        "%s km from route": [
          "%s km du trajet"
        ],
        "%s mi": [
          "%s mi"
        ],
        "%s mi from route": [
          "%s mi du trajet"
        ],
        "%s miles": [
          "%s milles"
        ],
        "%s result in": [
          "%s résultat dans",
          "%s résultats dans"
        ],
        "%s station along the route": [
          "%s station sur le trajet",
          "%s stations sur le trajet"
        ],
        "%s station location": [
          "%s emplacement de la station",
          "%s emplacements de stations"
        ],
        "100 miles between stations": [
          "100 milles (160,9 km) entre les stations"
        ],
        "150 miles between stations": [
          "150 milles (241,4 km) entre les stations"
        ],
        "200 miles between stations": [
          "200 milles (321,9 km) entre les stations"
        ],
        "5 miles from the highway": [
          "À 5 milles (8 km) de l’autoroute"
        ],
        "50 miles between stations": [
          "50 milles (80,5 km) entre les stations"
        ],
        "A connector is what is plugged into a vehicle to charge it. Multiple connectors and connector types (such as CHAdeMO and CCS) can be available on one EVSE port, but only one vehicle will charge at a time. Connectors are sometimes called plugs.": [
          "Un connecteur est ce qui est branché à un véhicule pour le recharger. Différents types de connecteurs (comme CHAdeMO et CCS) sont accessibles sur un port, mais un seul véhicule peut être rechargé à la fois. Les connecteurs sont parfois désignés sous le terme de « prises »."
        ],
        "A driving route could not be found between your starting and ending locations.": [
          "Aucun trajet n'a pu être établi entre votre point de départ et d'arrivée."
        ],
        "A station location is a site with one or more EVSE ports at the same address. Examples include a parking garage or a mall parking lot.": [
          "Un emplacement de station est un site où se trouvent un ou plusieurs ports, comme les stationnements intérieurs ou les stationnements des centres commerciaux."
        ],
        "A valid email address is required.": [
          "Une adresse courriel valide est nécessaire."
        ],
        "ACME": [
          "ACME"
        ],
        "About the Alternative Fueling Station Data": [
          "À propos des données sur les stations de ravitaillement en carburants de remplacement"
        ],
        "About the Data": [
          "À propos des données"
        ],
        "Access": [
          "Accès"
        ],
        "Access:": [
          "Accès :"
        ],
        "Accommodates all vehicle sizes and classes": [
          "Peut accueillir toutes les tailles et classes de véhicules"
        ],
        "Accommodates all vehicle sizes and classes.": [
          "Peut accueillir toutes les classes et tailles de véhicules."
        ],
        "Accommodates heavy-duty vehicles (Class 6-8).": [
          "Peut accueillir les camions lourds (classe 6 à 8)."
        ],
        "Accommodates light-duty vehicles only (i.e., passenger vehicles, light-duty pickups, and utility vans)": [
          "Peut accueillir uniquement les véhicules légers (c.-à-d. voitures de tourisme, camionnettes et fourgonnettes)"
        ],
        "Accommodates medium-duty vehicles (Class 3-5).": [
          "Peut accueillir les véhicules de poids moyen (classe 3 à 5)."
        ],
        "Accommodates passenger vehicles only (Class 1-2).": [
          "Peut accueillir uniquement les véhicules de tourisme (classe 1 et 2)."
        ],
        "Accommodates vehicles up to Class 5 (i.e., box trucks and cargo vans)": [
          "Peut accueillir les véhicules jusqu’à la classe 5 (c.-à-d. fourgons grand volume et fourgonnettes)"
        ],
        "Address": [
          "Adresse"
        ],
        "Address or postal code": [
          "Adresse ou code postal"
        ],
        "Advanced Filters": [
          "Filtres avancés"
        ],
        "Advanced filters section of the tool": [
          "Section « Filtres avancés » de l’outil"
        ],
        "Agriculture and Agri-Food": [
          "Agriculture et Agroalimentaire"
        ],
        "Airport": [
          "Aéroport"
        ],
        "Alberta": [
          "Alberta"
        ],
        "All": [
          "Tous"
        ],
        "All Fuels": [
          "Tous les carburants"
        ],
        "Alternate Route": [
          "Autre trajet"
        ],
        "Alternative Fuels Station Submission (%s)": [
          "Soumission concernant une station de ravitaillement en carburants de remplacement (%s)"
        ],
        "An EVSE port provides power to charge only one vehicle at a time even though it may have multiple connectors. The unit that houses EVSE ports is sometimes called a charging post, which can have one or more EVSE ports.": [
          "Un port d’EAVE agit comme une source d’alimentation pouvant recharger un seul véhicule à la fois (même s’il peut avoir plusieurs connecteurs). L’unité qui héberge les ports d’EAVE est parfois désignée sous le terme de « station de chargement », où un ou plusieurs ports peuvent être accessibles."
        ],
        "An unexpected error occurred. Please try again or contact us for assistance.": [
          "Une erreur est survenue. Veuillez réessayer ou communiquer avec nous pour obtenir de l'aide"
        ],
        "Android App": [
          "App Android"
        ],
        "Arena": [
          "Arène"
        ],
        "As the above networks transition to the OCPI protocol, NRCan works with each to integrate their OCPI-based API. This transition may result in increases to station counts because of the way that station data are shared under the protocol; one station may be split out into several new stations to represent different physical locations of EV chargers at one address (e.g., opposite sides of one parking lot). While the new stations may share the same street address, they may have different coordinates.": [
          "Alors que les réseaux susmentionnés réalisent une transition vers le protocole d’interface ouverte de point de recharge (OCPI), RNCan travaille avec chacun d’entre eux sur l’intégration de leur API développée en fonction de cette interface. Cette transition pourrait entraîner une augmentation du nombre de stations en raison de la façon dont leurs données sont partagées en vertu du protocole. En effet, une station pourrait être divisée en plusieurs nouvelles stations pour représenter différents emplacements de bornes de recharge pour VE présents à une seule adresse (p. ex., à des côtés opposés d’un stationnement). Les nouvelles stations peuvent avoir la même adresse municipale, mais des coordonnées différentes."
        ],
        "As the above networks transition to the OCPI protocol, NREL works with each to integrate their OCPI-based API. This transition may result in increases to station counts because of the way that station data are shared under the protocol; one station may be split out into several new stations to represent different physical locations of EV chargers at one address (e.g., opposite sides of one parking lot). While the new stations may share the same street address, they may have different coordinates.": [
          "Alors que les réseaux ci-dessus réalisent une transition vers le protocole d’interface ouverte de point de recharge (OCPI), le NREL travaille avec chacun d’entre eux sur l’intégration de leur API développée en fonction de cette interface. Cette transition pourrait entraîner une augmentation du nombre de stations en raison de la façon dont leurs données sont partagées en vertu du protocole. En effet, une station pourrait être divisée en plusieurs nouvelles stations pour représenter différents emplacements de bornes de recharge pour VE présents à une seule adresse (p. ex., à des côtés opposés d’un stationnement). Les nouvelles stations peuvent avoir la même adresse municipale, mais des coordonnées différentes."
        ],
        "Auto Repair Shop": [
          "Atelier de réparation automobile"
        ],
        "Available": [
          "Disponible"
        ],
        "Available Fuel(s)": [
          "Carburants disponibles"
        ],
        "B&B": [
          "Gîte"
        ],
        "Bank": [
          "Banque"
        ],
        "Because many public propane stations serve customers other than drivers and fleets, NREL collaborated with propane industry partners to establish and represent the differences. Each public propane station is designated as a \"primary\" or \"secondary\" service type, with both types able to fuel propane vehicles. However, locations with a \"primary\" designation offer vehicle-specific fueling capabilities.": [
          "Étant donné que plusieurs stations de propane publiques desservent des clients autres que des conducteurs et des parcs automobiles, NREL a collaboré avec les partenaires de l’industrie du propane pour établir et représenter les différences. Chaque station de propane publique est désignée comme un type de service « primaire » ou « secondaire », les deux types pouvant ravitailler les véhicules au propane. Toutefois, les emplacements ayant la désignation « principale » offrent des capacités de ravitaillement en carburant propres aux véhicules."
        ],
        "Beginning in 2021, public, non-networked electric vehicle (EV) charging stations will be proactively verified every other year, with half of the EV charging stations verified each year. This adjustment is to accommodate the growing number of EV charging stations in the Station Locator. NRCan will continue to make updates to any station record if changes are reported.": [
          "À compter de 2021, les stations publiques de recharge pour VE qui ne sont pas en réseau seront vérifiées de manière proactive tous les deux ans (la moitié des stations seront vérifiées chaque année). Cet ajustement tient compte du nombre croissant de stations de recharge pour VE dans le Localisateur de stations. RNCan continuera de mettre à jour les dossiers des stations si des changements sont signalés."
        ],
        "Beginning in 2021, public, non-networked electric vehicle (EV) charging stations will be proactively verified every other year, with half of the EV charging stations verified each year. This adjustment is to accommodate the growing number of EV charging stations in the Station Locator. NREL will continue to make updates to any station record if changes are reported.": [
          "À compter de 2021, les stations publiques de recharge pour VE qui ne sont pas en réseau seront vérifiées de manière proactive tous les deux ans (la moitié des stations seront vérifiées chaque année). Cet ajustement tient compte du nombre croissant de stations de recharge pour VE dans le Localisateur de stations. Le NREL continuera de mettre à jour les dossiers des stations si des changements sont signalés."
        ],
        "Biodiesel": [
          "Biodiesel"
        ],
        "Biodiesel (B20 and above)": [
          "Biodiesel (B20 et supérieur)"
        ],
        "Biodiesel Blends Available": [
          "Mélanges de biodiesels disponibles"
        ],
        "Biodiesel Stations": [
          "Stations de biodiesel"
        ],
        "Blends Available:": [
          "Mélanges disponibles :"
        ],
        "Both: fast-fill and time-fill": [
          "À la fois : remplissage rapide et lent"
        ],
        "Brewery/Distillery/Winery": [
          "Brasserie/distillerie/vinerie"
        ],
        "British Columbia": [
          "Colombie-Britannique"
        ],
        "Business Hours": [
          "Heures d’ouverture"
        ],
        "CCS": [
          "CCS"
        ],
        "CHAdeMO": [
          "CHAdeMO"
        ],
        "CNG": [
          "GNC"
        ],
        "CNG Capacity per Compressor (standard cubic feet per minute)": [
          "Capacité GNC par compresseur (pied cube standard par minute)"
        ],
        "CNG Dispensers Installed": [
          "Distributeurs de GNC installés"
        ],
        "CNG Fill Pressure (psi)": [
          "Pression de remplissage du GNC (lb/po2)"
        ],
        "CNG Fill Type": [
          "Type de remplissage du GNC"
        ],
        "CNG Renewable Energy Used": [
          "Énergie renouvelable utilisée en GNC"
        ],
        "CNG Total Storage Capacity (standard cubic feet)": [
          "Capacité de stockage totale de GNC (pied cube standard)"
        ],
        "Call ahead": [
          "Appeler à l'avance"
        ],
        "Campground": [
          "Terrain de camping"
        ],
        "Canada": [
          "Canada"
        ],
        "Canadian Heritage": [
          "Patrimoine canadien"
        ],
        "Canadian Heritage (Status of Women)": [
          "Patrimoine canadien (Condition féminine)"
        ],
        "Car Dealer": [
          "Concessionnaire automobile"
        ],
        "Card key after hours": [
          "Carte-clé après les heures d'ouverture"
        ],
        "Card key at all times": [
          "Carte-clé en tout temps"
        ],
        "Carwash": [
          "Lave-auto"
        ],
        "Cash": [
          "Argent comptant"
        ],
        "Caution:": [
          "Mise en garde :"
        ],
        "Charger Types": [
          "Types de chargeurs"
        ],
        "Charger types": [
          "Types de chargeurs"
        ],
        "Charging Infrastructure Terminology": [
          "Terminologie relative aux infrastructures de recharge"
        ],
        "Charging Network:": [
          "Réseau de recharge :"
        ],
        "Check": [
          "Vérifier"
        ],
        "City": [
          "Ville"
        ],
        "Clear end location": [
          "Effacer la destination"
        ],
        "Clear location": [
          "Effacer l’emplacement"
        ],
        "Clear start location": [
          "Effacer le point de départ"
        ],
        "Close": [
          "Fermer"
        ],
        "Co-Op": [
          "Coopérative"
        ],
        "College Campus": [
          "Campus collégial"
        ],
        "Comments": [
          "Commentaires"
        ],
        "Compressed Natural Gas (CNG)": [
          "Gaz naturel comprimé (GNC)"
        ],
        "Compressed natural gas stations also list fill type and fill pressure in the details page. These fields are also searchable using the Fuel button on the \"Advanced Filters\" tab.": [
          "Les stations de gaz naturel comprimé indiquent également le type de remplissage et la pression de remplissage qu'elles proposent dans la page des détails. On peut rechercher ces champs en utilisant le bouton « Carburant » dans l’onglet « Filtres avancés »."
        ],
        "Connector": [
          "Connecteur"
        ],
        "Connectors": [
          "Raccords"
        ],
        "Connectors:": [
          "Connecteurs :"
        ],
        "Convenience Store": [
          "Dépanneur"
        ],
        "Convention Center": [
          "Centre des congrès"
        ],
        "Copy and paste this HTML into your website.": [
          "Copiez et collez ce code HTML dans votre site Web"
        ],
        "Corridor Measurement": [
          "Mesures des corridors"
        ],
        "Country": [
          "Pays"
        ],
        "Credit": [
          "Crédit"
        ],
        "Credit Card": [
          "Carte de crédit"
        ],
        "Credit card after hours": [
          "Carte de crédit après les heures d'ouverture"
        ],
        "Credit card at all times": [
          "Carte de crédit en tout temps"
        ],
        "Criteria for Corridors": [
          "Critères pour les corridors"
        ],
        "DC Fast": [
          "Courant continu rapide"
        ],
        "DC fast charging available": [
          "Recharge DC Fast disponible"
        ],
        "Data Collection Methods": [
          "Méthodes de collecte des données"
        ],
        "Data for this station comes from the %s network. You can use this form to suggest updates, but we also recommend that you <a href='%s'>contact the network</a> directly to report changes because we cannot edit station information for this network.": [
          "Les données de cette station proviennent de %s. Vous pouvez utiliser le présent formulaire pour proposer des mises à jour, mais nous vous recommandons aussi de <a href='%s'>communiquer directement avec le réseau</a> pour signaler des changements, car nous ne pouvons pas modifier les informations relatives à ce réseau."
        ],
        "Debit": [
          "Débit"
        ],
        "Debit Card": [
          "Carte de débit"
        ],
        "Developer API": [
          "Les API des développeurs"
        ],
        "Developer APIs": [
          "API des développeurs"
        ],
        "Diagram of an electric vehicle charging station showing how one station can have multiple EVSE ports and each EVSE port can have one or more connectors": [
          "Schéma d’une station de recharge pour véhicules électriques montrant que plusieurs ports d’EAVE peuvent être accessibles à une station et que chaque port d’EAVE peut avoir un ou plusieurs connecteurs."
        ],
        "Directions": [
          "Directions"
        ],
        "Distance from the Route to Show Stations": [
          "Distance de la route pour montrer les stations"
        ],
        "Download Data": [
          "Télécharger les données"
        ],
        "Download Results": [
          "Télécharger les résultats"
        ],
        "Download list of stations on route": [
          "Télécharger la liste des stations sur le trajet"
        ],
        "Duplicate": [
          "Duplicata"
        ],
        "E15": [
          "E15"
        ],
        "E20-E25": [
          "E20-E25"
        ],
        "E30-E35": [
          "E30-E35"
        ],
        "E40 and above": [
          "E40 et plus"
        ],
        "EV Charging Stations": [
          "Stations de recharge pour VE"
        ],
        "EVSE Port": [
          "Port d’EAVE"
        ],
        "EVSE Ports": [
          "Ports d’EAVE"
        ],
        "Each point on the map is counted as one station in the station count. A station appears as one point on the map, regardless of the number of fuel dispensers or electric vehicle supply equipment (EVSE) ports at that location. Station addresses are geocoded and mapped using an automatic geocoding application. The geocoding application returns the most accurate location based on the provided address. Station locations may also be provided by external sources (e.g., station operators) and/or verified in a geographic information system (GIS) tool. This information is considered highly accurate, and these coordinates override any information generated using the geocoding application.": [
          "Chaque point sur la carte compte pour une station dans le dénombrement des stations. Une station apparaît comme un seul point sur la carte, peu importe le nombre de distributeurs de carburant ou de ports d’équipement d’alimentation de véhicules électriques (EAVE) qui se trouvent à cet emplacement. Les adresses des stations sont géocodées et cartographiées à l’aide d’une application de géocodage automatique qui fournit l’emplacement le plus exact selon l’adresse fournie. Les emplacements de stations peuvent aussi être fournis par des sources externes (p. ex., exploitants de stations) ou vérifiés dans un système d’information géographique (SIG). Ces coordonnées sont jugées extrêmement précises et ont préséance sur tout renseignement généré par l’application de géocodage."
        ],
        "Each point on the map is counted as one station in the station count. The number of EVSE ports and types of connectors available at each station location are displayed in the details page for each station location. Users may search by charger types, connectors, and networks using the Fuel button on the \"Advanced Filters\" tab.": [
          "Chaque point sur la carte compte pour une station dans le dénombrement des stations. Le nombre de ports d’EAVE et de types de connecteurs à chaque station est affiché dans la page de renseignements pour chaque emplacement de station. Les utilisateurs peuvent effectuer une recherche par type de chargeur, par connecteur et par réseau à l’aide du bouton « Carburant » de l’onglet « Filtres avancés »."
        ],
        "Edit Filters": [
          "Modifier les filtres"
        ],
        "Electric": [
          "Électrique"
        ],
        "Electric Charging Manufacturer": [
          "Fabricant de recharge électrique"
        ],
        "Electric Charging Network": [
          "Réseau de recharge électrique"
        ],
        "Electric Charging Power (kW)": [
          "Puissance de recharge électrique (kW)"
        ],
        "Electric Charging Pricing": [
          "Fixation des prix de la recharge électrique"
        ],
        "Electric Charging Renewable Energy Used": [
          "Énergie renouvelable utilisée de chargement électrique"
        ],
        "Electric Vehicle Charging": [
          "Recharge de véhicule électrique"
        ],
        "Email": [
          "Courriel"
        ],
        "Embed Tool": [
          "Intégrer l'outil"
        ],
        "Embed the Alternative Fueling Station Locator": [
          "Intégrer le localisateur de stations de ravitaillement en carburants de remplacement"
        ],
        "Embed the station locator using the results you are currently viewing as the default.": [
          "Intégrer le localisateur de stations à l'aide des résultats que vous voyez actuellement par défaut."
        ],
        "Employment, Workforce Development and Labour": [
          "Emploi, Développement de la main d'oeuvre et Travail"
        ],
        "End location": [
          "destination"
        ],
        "Enter an address or postal code": [
          "Saisir une adresse ou un code postal"
        ],
        "Enter location": [
          "Saisir l'emplacement"
        ],
        "Environment and Climate Change": [
          "Environnement et Changement climatique"
        ],
        "Ethanol": [
          "Éthanol"
        ],
        "Ethanol (E85)": [
          "Éthanol (E85)"
        ],
        "Ethanol (E85) Stations": [
          "Stations d’éthanol (E85)"
        ],
        "Ethanol Other Blends Offered": [
          "Autres mélanges d'éthanol offerts"
        ],
        "Existing": [
          "Existant"
        ],
        "Existing stations in the database are contacted at least once a year on an established schedule to verify they are still operational and providing the fuel specified. Based on an established data collection schedule, the database is updated on an ongoing basis. Stations that are no longer operational or no longer provide alternative fuel are removed from the database as they are identified.": [
          "Au moins une fois par année, selon un calendrier établi, on communique avec les stations contenues dans la base de données pour vérifier qu’elles sont encore opérationnelles et qu’elles fournissent le carburant indiqué. La base de données est mise à jour de façon continue, selon un calendrier établi de collecte de données. Les stations qui ne sont plus opérationnelles ou qui ne fournissent plus de carburants de remplacement sont retirées de la base de données à mesure qu’elles sont identifiées."
        ],
        "Expected Open/Reopen Date": [
          "Date prévue d'ouverture / réouverture"
        ],
        "Factory": [
          "Usine"
        ],
        "Families, Children and Social Development": [
          "Famille, Enfants et Développement social"
        ],
        "Fast-fill": [
          "Remplissage rapide"
        ],
        "Fast-fill and time-fill": [
          "Remplissage rapide et remplissage minuté"
        ],
        "Federal Government": [
          "Gouvernement fédéral"
        ],
        "Federal Government Owned": [
          "Détenu par le gouvernement fédéral"
        ],
        "Fill Pressure:": [
          "Pression de remplissage :"
        ],
        "Fill Type:": [
          "Type de remplissage :"
        ],
        "Fill pressure": [
          "Pression de remplissage"
        ],
        "Fill type": [
          "Type de remplissage"
        ],
        "Filter by Fuel Type": [
          "Filtrer par type de carburant"
        ],
        "Filter by Location": [
          "Filtrer par emplacement"
        ],
        "Filter by Station Details": [
          "Filtrer par détails sur les stations"
        ],
        "Filters chosen:": [
          "Filtres choisis :"
        ],
        "Finance": [
          "Finances"
        ],
        "Find Stations": [
          "Trouver les stations"
        ],
        "Fire Station": [
          "Caserne de pompiers"
        ],
        "First Name": [
          "Prénom"
        ],
        "Fisheries, Oceans and the Canadian Coast Guard": [
          "Pêches, Océans et Garde Côtière Canadienne"
        ],
        "Fleet Card": [
          "Carte de parc automobile"
        ],
        "Fleet Garage": [
          "Parc de la flotte"
        ],
        "Fleet customers only": [
          "Réservé aux clients de parcs"
        ],
        "For more information about the data, contact the <a href='%s'>webmaster</a> or refer to the <a href='%s'>list of data fields</a>.": [
          "Pour de plus amples renseignements sur les données, veuillez communiquer avec le <a href='%s'>webmestre</a> ou reportez-vous à la <a href='%s'>liste des champs de données</a>."
        ],
        "For more information about the data, contact the <a href='%s'>webmaster</a>.": [
          "Pour de plus amples renseignements sur les données, veuillez communiquer avec le <a href='%s'>webmestre</a>."
        ],
        "Fuel": [
          "Carburant"
        ],
        "Fuel Corridors": [
          "Corridors de carburant"
        ],
        "Fuel Reseller": [
          "Revendeur de carburant"
        ],
        "Fuel cell electric vehicle drivers have access to hydrogen stations in certain areas of the country. Because this technology is in the early commercialization stages, the status of hydrogen fueling stations may change more frequently than other fuel types. To allow users to monitor station status more closely, hydrogen stations now indicate whether or not they have reduced fueling capacity.": [
          "Les conducteurs de véhicules électriques à pile à combustible ont accès à des stations d’hydrogène dans certaines régions du pays. Étant donné que cette technologie en est aux premiers stades de sa commercialisation, le statut des stations de ravitaillement en hydrogène peut changer plus fréquemment que pour les autres types de carburant. Pour permettre aux utilisateurs de surveiller de plus près le statut de la station, les stations d’hydrogène indiquent maintenant si leur capacité de ravitaillement est réduite."
        ],
        "Fuel cell electric vehicle drivers may have access to hydrogen stations in certain areas of the country. Because this technology is in the early commercialization stages, the status of hydrogen fueling stations may change more frequently than other fuel types. To allow users to monitor station status more closely, hydrogen stations now indicate whether or not they have reduced fueling capacity.": [
          "Les conducteurs de véhicule électrique à pile à combustible peuvent avoir accès à des stations proposant de l'hydrogène dans certaines régions du pays. Du fait que cette technologie n’en soit qu’aux premiers stades de commercialisation, le statut des stations proposant de l’hydrogène peut changer plus fréquemment que pour d’autres types de carburant. Pour permettre aux utilisateurs de surveiller de plus près le statut des stations, celles proposant de l’hydrogène indiquent désormais si elles ont une capacité de ravitaillement réduite ou non."
        ],
        "GPS": [
          "GPS"
        ],
        "General comments": [
          "Observations générales"
        ],
        "Geothermal": [
          "Géothermique"
        ],
        "Global Affairs (Foreign Affairs)": [
          "Affaires mondiales (Affaires étrangères)"
        ],
        "Global Affairs (International Development)": [
          "Affaires mondiales (Développement international)"
        ],
        "Global Affairs (International Trade)": [
          "Affaires mondiales (Développement international)"
        ],
        "Government only": [
          "Réservé au gouvernement"
        ],
        "Grocery Store": [
          "Épicerie"
        ],
        "HTML": [
          "HTML"
        ],
        "Hardware Store": [
          "Quincaillerie"
        ],
        "Health": [
          "Santé"
        ],
        "Heavy-duty (Class 6-8)": [
          "Véhicules lourds (classes 6 à 8)"
        ],
        "Heavy-duty (class 6-8)": [
          "Camion lourd (classe 6 à 8)"
        ],
        "Help": [
          "Aide"
        ],
        "Hospital": [
          "Hôpital"
        ],
        "Hotel": [
          "Hôtel"
        ],
        "Hydrogen": [
          "Hydrogène"
        ],
        "Hydrogen Pressure": [
          "Pression d'hydrogène"
        ],
        "Hydrogen SAE Standards Compliance": [
          "Conformité aux normes SAE sur l'hydrogène"
        ],
        "Hydrogen Stations": [
          "Stations d’hydrogène"
        ],
        "Hydropower": [
          "Énergie hydroélectrique"
        ],
        "If you have more than one station to add or update, contact the <a href='%s'>Technical Response Service</a> for a spreadsheet.": [
          "Si vous avez plus d’une station à ajouter ou à mettre à jour, communiquez avec le <a href='%s'>Service de réponse technique</a> pour obtenir une feuille de calcul."
        ],
        "Immigration, Refugees and Citizenship": [
          "Immigration, Réfugiés et Citoyenneté"
        ],
        "In addition to marking the station as out of service on this form, please report any broken equipment or access issues to the station owner.": [
          "En plus d'indiquer la station hors service sur ce formulaire, veuillez signaler tout équipement brisé ou problème d'accès au propriétaire de la station."
        ],
        "Include non-retail stations": [
          "Inclure les stations qui ne vendent pas au détail."
        ],
        "Include only stations offering mid-level blends": [
          "Inclure uniquement les stations offrant les mélanges à teneur moyenne"
        ],
        "Include stations with limited vehicle fueling": [
          "Inclure les stations avec des services limités de ravitaillement pour véhicules"
        ],
        "Include stations with limited vehicle fueling capabilities": [
          "Inclure les stations dont les capacités de ravitaillement en carburant des véhicules sont limitées"
        ],
        "Includes non-retail stations": [
          "Comprend les stations qui ne vendent pas au détail."
        ],
        "Includes stations with limited vehicle-specific fueling capabilities": [
          "Inclut les stations avec des possibilités de remplissage pour des types précis de véhicules "
        ],
        "Indicate when the station went out of service and why it closed": [
          "Indiquez le moment auquel la station a cessé de fonctionner et pourquoi elle a fermé."
        ],
        "Indigenous and Northern Affairs": [
          "Affaires autochtones et du Nord"
        ],
        "Infrastructure and Communities": [
          "Infrastructure et Collectivités"
        ],
        "Inn": [
          "Auberge"
        ],
        "Innovation, Science and Economic Development": [
          "Innovation, Sciences et Développement économique"
        ],
        "J1772": [
          "J1772"
        ],
        "J2601": [
          "J2601"
        ],
        "J2601-2": [
          "J2601-2"
        ],
        "Jointly Owned": [
          "Propriété conjointe"
        ],
        "Justice": [
          "Ministère de la Justice"
        ],
        "LNG": [
          "GNL"
        ],
        "LNG Renewable Energy Used": [
          "Énergie renouvelable utilisée de GNL"
        ],
        "Landfill": [
          "Décharge"
        ],
        "Last Name": [
          "Nom"
        ],
        "Last confirmed: %s": [
          "Confirmé la dernière fois : %s"
        ],
        "Latitude": [
          "Latitude"
        ],
        "Leader of the Government in the House of Commons": [
          "Leader du gouvernement à la Chambre des communes"
        ],
        "Learn about the station location data collection methods, update schedules, and station details.": [
          "Renseignez-vous sur les méthodes de collecte de données sur l’emplacement des stations, les calendriers de mise à jour et les détails sur les stations."
        ],
        "Legacy chargers": [
          "Anciens chargeurs"
        ],
        "Legend": [
          "Légende"
        ],
        "Level 1": [
          "Niveau 1"
        ],
        "Level 1 charging is a 120V standard wall plug using a J1772 connector. Provides 2 to 5 miles of range per 1 hour of charging.": [
          "La recharge de niveau 1 est une prise murale standard de 120V utilisant un raccord J1772. Fournit de 2 à 5 milles de trajet par heure de recharge."
        ],
        "Level 1 charging is a 120V standard wall plug using a J1772 connector. Provides 3 to 8 kilometers of range per 1 hour of charging.": [
          "La recharge de niveau 1 est une prise murale standard de 120V utilisant un raccord J1772. Fournit de 3 à 8 km de trajet par heure de recharge."
        ],
        "Level 1 electric vehicle charging available": [
          "Recharge pour véhicule électrique de niveau 1 disponible"
        ],
        "Level 2": [
          "Niveau 2"
        ],
        "Level 2 charging uses 240V/208V for residential or commercial charging using a J1772 connector. Provides 10 to 20 miles of range per 1 hour of charging.": [
          "La recharge de niveau 2 utilise 240V/208V pour la recharge résidentielle ou commerciale utilisant un raccord J1772. Fournit de 10 à 20 milles de trajet par heure de recharge."
        ],
        "Level 2 charging uses 240V/208V for residential or commercial charging using a J1772 connector. Provides 16 to 32 kilometers of range per 1 hour of charging.": [
          "La recharge de niveau 2 utilise 240V/208V pour la recharge résidentielle ou commerciale utilisant un raccord J1772. Fournit de 16 à 32 kilomètres de trajet par heure de recharge."
        ],
        "Level 2 electric vehicle charging available": [
          "Recharge pour véhicule électrique de niveau 2 disponible"
        ],
        "Level 3": [
          "Niveau 3"
        ],
        "Library": [
          "Bibliothèque"
        ],
        "Limit results to within": [
          "Limiter les résultats à un rayon de"
        ],
        "Limited hours": [
          "Heures limitées"
        ],
        "Liquefied Natural Gas (LNG)": [
          "Gaz naturel liquéfié (GNL)"
        ],
        "Livestock Operations": [
          "Opérations d'élevage"
        ],
        "Local/Municipal Government Owned": [
          "Détenu par l’administration locale/municipale"
        ],
        "Location": [
          "Lieu"
        ],
        "Longitude": [
          "Longitude"
        ],
        "Manitoba": [
          "Manitoba"
        ],
        "Many public propane stations serve customers other than drivers and fleets. To represent the differences, each public propane station is designated as a \"primary\" or \"secondary\" service type, with both types able to fuel propane vehicles. However, locations with a \"primary\" designation offer vehicle-specific fueling capabilities.": [
          "De nombreuses stations publiques proposant du propane servent des clients autre que les conducteurs et les parcs automobiles. Pour représenter les différences, chaque station publique proposant du propane est désignée comme type de service « principal » ou « secondaire », les deux types permettant de ravitailler les véhicules roulant au propane. Toutefois, les emplacements ayant la désignation « principale » offrent des capacités de ravitaillement en carburant propres aux véhicules."
        ],
        "Map Results": [
          "Résultats de la carte"
        ],
        "Map a Route": [
          "Établir un trajet"
        ],
        "Mapping and Counting Methods": [
          "Méthodes de cartographie et de dénombrement"
        ],
        "Medium-duty (Class 3-5)": [
          "Véhicules moyens (classes 3 à 5)"
        ],
        "Medium-duty (class 3-5)": [
          "Camion de poids moyen (classe 3 à 5)"
        ],
        "Mid-Level Blends:": [
          "Mélanges à teneur moyenne :"
        ],
        "Military Base": [
          "Base militaire"
        ],
        "More": [
          "Plus"
        ],
        "More Information": [
          "Pour plus de renseignements"
        ],
        "Motor Pool": [
          "Parc de véhicules"
        ],
        "Multi-Family Housing": [
          "Logement multifamilial"
        ],
        "Municipal Government": [
          "Gouvernement municipal"
        ],
        "Museum": [
          "Musée"
        ],
        "NEMA 14-50": [
          "NEMA 14-50"
        ],
        "NEMA 5-15": [
          "NEMA 5-15"
        ],
        "NEMA 5-20": [
          "NEMA 5-20"
        ],
        "NRCan collects and publishes data on planned station locations, particularly those that are sited and have begun the installation process. In addition, the Station Locator includes stations that are temporarily out of service or offline with plans to open again in the future. To include planned and temporarily unavailable stations in the search results, use the \"Advanced Filters\" tab.": [
          "RNCan recueille et publie des données sur les emplacements des stations prévues, surtout sur celles dont l’installation est déjà commencée. De plus, le Localisateur de stations comprend des stations qui sont temporairement hors service ou hors ligne et qui devraient ouvrir de nouveau à l’avenir. Pour inclure les stations prévues et temporairement non disponibles dans les résultats de recherche, utilisez l’onglet « Filtres avancés »."
        ],
        "NRCan is in the process of transitioning EV charging station counting logic to align with the hierarchy defined in the Open Charge Point Interface (OCPI) protocol: station location, EVSE port, and connector. With this transition, NRCan is updating the number of EVSE ports (formerly called charging outlets) in the Stations Locator, which represents the number of vehicles that can charge simultaneously at a station location. The Station Locator also identifies the available connector types. Both the total number of station locations and EVSE ports appear in the EV charging search results on the \"Advanced Filters\" tab.": [
          "RNCan s’affaire à réaliser la transition de la logique de dénombrement des stations de recharge pour VE afin de se conformer à la hiérarchie définie dans le protocole d’interface ouverte de point de recharge (OCPI) : emplacement des stations, ports d’EAVE et connecteurs. Dans le cadre de cette transition, RNCan actualise le nombre de ports d’EAVE (anciennement appelés « prises de recharge ») du localisateur de stations, qui représente le nombre de véhicules pouvant être rechargés en même temps à une station. Le Localisateur de stations indique également les types de connecteurs accessibles. Le nombre total de stations et de ports d’EAVE apparaissent dans les résultats de recherche des stations de recharge pour VE dans l’onglet « Filtres avancés »."
        ],
        "NRCan recommends users verify a station is open, available to the public, and has the desired alternative fuel prior to making a trip to that location.": [
          "RNCan recommande aux utilisateurs de vérifier qu’une station est ouverte au public et qu’elle dispose des carburants de remplacement voulus avant de s’y rendre."
        ],
        "NRCan regularly compares its station data with those of other relevant trade organizations and websites. Differences in methodologies, data confirmation, and inclusion criteria may result in slight variations between NRCan's database and those maintained by other organizations. NRCan also collaborates with alternative fuel industry groups to identify discrepancies in data and develop data sharing processes and best practices. NRCan and its data collection subcontractor are currently collaborating with alternative fuel industry groups to ensure best practices are being followed for identifying new stations and confirming station changes in the most-timely manner possible.": [
          "RNCan compare régulièrement les données sur les stations avec celles d’autres organisations commerciales et de sites Web pertinents. Des différences dans les méthodes, la confirmation des données et les critères d’inclusion peuvent entraîner de légers écarts entre la base de données de RNCan et celles d’autres organisations. RNCan collabore aussi avec des groupes de l’industrie des carburants de remplacement en vue de déceler des écarts dans les données et d’élaborer des processus de partage des données et des pratiques exemplaires. RNCan et l’entrepreneur qui recueille ses données collaborent avec les groupes de l’industrie des carburants de remplacement afin de s’assurer que les pratiques exemplaires sont respectées dans le but d’identifier les nouvelles stations et de confirmer les changements dans les stations dans les meilleurs délais possibles."
        ],
        "NREL collaborated with industry groups to revisit the definition of public hydrogen stations and refined the Station Locator data to differentiate between stations that are only available to a certain subset of customers (e.g., require an access card, PIN, or training) and those that are considered retail locations (e.g., accept payment at the point of sale). Access designations are available in the details page for each public station. The Station Locator defaults to showing only public retail stations. Users may expand their search to include all public hydrogen stations by selecting the \"Include non-retail stations\" checkbox.": [
          "NREL a collaboré avec des groupes de l’industrie pour repenser la définition des stations d’hydrogène publiques et affiner les données du Localisateur de stations pour faire la distinction entre les stations qui ne sont accessibles qu’à un certain sous-ensemble de clients (p. ex., les stations pour lesquelles une carte d’accès, un code NIP ou une formation sont nécessaires) et celles qui sont considérées comme des points de vente au détail (p. ex., celles qui acceptent un paiement au point de vente). Les désignations d’accès sont accessibles à la page de détails pour chaque station publique. Par défaut, le Localisateur de stations n’affiche que les stations publiques de vente au détail. Les utilisateurs peuvent élargir leur recherche pour y inclure toutes les stations d’hydrogène publiques en cochant la case « Inclure les stations autres que les stations de vente au détail »."
        ],
        "NREL collects and publishes data on planned station locations, particularly those that are sited and have begun the installation process. In addition, the Station Locator includes stations that are temporarily out of service or offline with plans to open again in the future. To include planned and temporarily unavailable stations in the search results, use the \"Advanced Filters\" tab.": [
          "NREL recueille et publie des données sur les emplacements des stations prévues, notamment sur celles dont l’installation a déjà commencé. De plus, le Localisateur de stations comprend des stations qui sont temporairement hors service ou hors ligne et qui devraient ouvrir de nouveau à l’avenir. Pour inclure les stations prévues et temporairement non disponibles dans les résultats de recherche, utilisez l’onglet « Filtres avancés »."
        ],
        "NREL is in the process of transitioning EV charging station counting logic to align with the hierarchy defined in the Open Charge Point Interface (OCPI) protocol: station location, EVSE port, and connector. With this transition, NREL is updating the number of EVSE ports (formerly called charging outlets) in the Stations Locator, which represents the number of vehicles that can charge simultaneously at a station location. The Station Locator also identifies the available connector types. Both the total number of station locations and EVSE ports appear in the EV charging search results on the \"Advanced Filters\" tab.": [
          "Le NREL des États-Unis s’affaire à réaliser la transition de la logique de dénombrement des stations de recharge pour VE pour convenir à la hiérarchie définie dans le protocole d’interface ouverte de point de recharge (OCPI) : emplacement des stations, ports d’EAVE et connecteurs. Dans le cadre de cette transition, le NREL actualise le nombre de ports d’EAVE (anciennement appelés « prises de recharge ») du localisateur de stations, qui représente le nombre de véhicules pouvant être rechargés en même temps à une station. Le Localisateur de stations indique également les types de connecteurs accessibles. Le nombre total de stations et de ports d’EAVE apparaissent dans les résultats de recherche des stations de recharge pour VE dans l’onglet « Filtres avancés »."
        ],
        "NREL regularly compares its station data with those of other relevant trade organizations and websites. Differences in methodologies, data confirmation, and inclusion criteria may result in slight variations between NREL's database and those maintained by other organizations. NREL also collaborates with alternative fuel industry groups to identify discrepancies in data and develop data sharing processes and best practices. NREL and its data collection subcontractor are currently collaborating with natural gas, electric drive, biodiesel, ethanol, hydrogen, and propane industry groups to ensure best practices are being followed for identifying new stations and confirming station changes in the most-timely manner possible.": [
          "NREL compare régulièrement les données sur les stations avec celles d’autres organisations commerciales et de sites Web pertinents. Des différences dans les méthodes, la confirmation des données et les critères d’inclusion peuvent entraîner de légers écarts entre la base de données de NREL et celles d’autres organisations. NREL collabore aussi avec des groupes de l’industrie des carburants de remplacement en vue de déceler des écarts dans les données et d’élaborer des processus de partage des données et des pratiques exemplaires. NREL et l’entrepreneur qui recueille ses données collaborent avec les groupes de l’industrie du gaz naturel, de la propulsion électrique, du biodiésel, de l'éthanol, de l'hydrogène et du propane afin de s’assurer que les pratiques exemplaires sont respectées dans le but de repérer les nouvelles stations et de confirmer les changements dans les stations dans les meilleurs délais possibles."
        ],
        "National Defence": [
          "Défense nationale"
        ],
        "National Park": [
          "Parc national"
        ],
        "National Revenue": [
          "Revenu national"
        ],
        "Natural Gas Stations": [
          "Stations de gaz naturel"
        ],
        "Natural Resources": [
          "Ressources naturelles"
        ],
        "Natural Resources Canada": [
          "Ressources naturelles Canada"
        ],
        "Networks": [
          "Réseaux"
        ],
        "Networks:": [
          "Réseaux :"
        ],
        "New Brunswick": [
          "Nouveau-Brunswick"
        ],
        "Newfoundland and Labrador": [
          "Terre-Neuve-et-Labrador"
        ],
        "Next": [
          "Prochain"
        ],
        "No": [
          "Non"
        ],
        "Non-Networked": [
          "Non-réseautés"
        ],
        "None": [
          "Aucun"
        ],
        "Northwest Territories": [
          "Territoires du Nord-Ouest"
        ],
        "Note that several states, including Alabama, Indiana, Kansas, Missouri, and Oklahoma, require or allow in-state propane vehicles to obtain a decal in lieu of paying state fuel taxes at the pump. Out-of-state vehicles may still be subject to taxes at the pump. Determinations about price differential (for the purposes of the primary or secondary propane station designation) are made assuming that the vehicle has an in-state decal. For more information about state decals and similar laws and regulations, visit the <a href='%s'>AFDC Laws & Incentives</a> database.": [
          "Il convient de noter que plusieurs États, dont l’Alabama, l’Indiana, le Kansas, le Missouri et l’Oklahoma imposent ou permettent aux véhicules fonctionnant au gaz propane immatriculés dans l’État d’obtenir un autocollant plutôt que de payer les taxes sur le carburant à la pompe. Les véhicules immatriculés en dehors de l’État peuvent encore être sujets à des taxes à la pompe. Le différentiel de prix (aux fins de la désignation de la station de propane primaire ou secondaire) est établi en supposant que le véhicule est équipé d’un autocollant d’État. Pour obtenir de plus amples renseignements sur les autocollants d’État et les lois et réglementations similaires, consultez la base de données des <a href='%s'>mesures incitatives et des lois de l’AFDC</a>."
        ],
        "Notes about Specific Station Types": [
          "Notes sur les types précis de stations"
        ],
        "Nova Scotia": [
          "Nouvelle-Écosse"
        ],
        "Number of DC Fast Ports": [
          "Nombre de bornes DC Fast"
        ],
        "Number of Level 1 Ports": [
          "Nombre de bornes de niveau 1"
        ],
        "Number of Level 2 Ports": [
          "Nombre de bornes de niveau 2"
        ],
        "Nunavut": [
          "Nunavut"
        ],
        "Office Building": [
          "Immeuble de bureaux"
        ],
        "Only DC fast charging stations with CHAdeMO and CCS connectors (no Tesla)": [
          "Stations de courant continu rapide avec connecteurs CHAdeMO et CCS seulement (pas Tesla)"
        ],
        "Only fast-fill stations with 3,600 psi fill pressure": [
          "Stations à remplissage rapide avec pression de remplissage de 3 600 psi seulement"
        ],
        "Only primary stations (offer fueling capabilities for vehicles)": [
          "Stations primaires seulement (fournissent une capacité de ravitaillement en carburant de remplacement pour les véhicules)"
        ],
        "Only public stations": [
          "Stations publiques seulement"
        ],
        "Only retail stations (accept payment at the point of sale)": [
          "Stations de vente au détail (acceptent les paiements au point de vente)"
        ],
        "Only stations with mid-level blends": [
          "Uniquement les stations offrant les mélanges à teneur moyenne"
        ],
        "Ontario": [
          "Ontario"
        ],
        "Open Date": [
          "Date d'ouverture"
        ],
        "Optional Fuel Information": [
          "Renseignements facultatifs sur le carburant"
        ],
        "Optional Station Information": [
          "Renseignements facultatifs sur la station"
        ],
        "Other": [
          "Autre"
        ],
        "Other Blends Offered:": [
          "Autres mélanges offerts :"
        ],
        "Other Entertainment": [
          "Autre divertissement"
        ],
        "Out of Service": [
          "Hors service"
        ],
        "Owner": [
          "Propriétaire"
        ],
        "Owner:": [
          "Propriétaire :"
        ],
        "PLANNED - not yet accessible": [
          "PRÉVU - pas encore accessible"
        ],
        "Page": [
          "Page"
        ],
        "Park": [
          "Parc"
        ],
        "Parking Garage": [
          "Parc de stationnement couvert"
        ],
        "Parking Lot": [
          "Terrain de stationnement"
        ],
        "Parliament": [
          "Parlement"
        ],
        "Passenger vehicles (Class 1-2)": [
          "Véhicules à passagers (classes 1 et 2)"
        ],
        "Passenger vehicles (class 1-2)": [
          "Véhicules de tourisme (classe 1 et 2)"
        ],
        "Pay-Parking Garage": [
          "Parc de stationnement couvert payant"
        ],
        "Pay-Parking Lot": [
          "Terrain de stationnement payant"
        ],
        "Payment": [
          "Paiement"
        ],
        "Payment Types": [
          "Types de paiement"
        ],
        "Payment:": [
          "Paiement :"
        ],
        "Pending Corridor": [
          "Corridor en attente"
        ],
        "Pharmacy": [
          "Pharmacie"
        ],
        "Phone": [
          "Téléphone"
        ],
        "Place of Worship": [
          "Lieu de culte"
        ],
        "Plan Cancelled": [
          "Pojet annulé"
        ],
        "Planned": [
          "Prévue"
        ],
        "Planned and Temporarily Unavailable Stations": [
          "Stations prévues et temporairement non disponibles"
        ],
        "Please Note:": [
          "Remarque :"
        ],
        "Postal Code": [
          "Code postal"
        ],
        "President of the Queen's Privy Council for Canada": [
          "Président du Conseil privé de la Reine pour le Canada"
        ],
        "Pressure Available:": [
          "Pression disponible :"
        ],
        "Prev": [
          "Préc"
        ],
        "Prime Minister": [
          "Premier ministre"
        ],
        "Prince Edward Island": [
          "Île-du-Prince-Édouard"
        ],
        "Prison": [
          "Prison"
        ],
        "Private": [
          "Privé"
        ],
        "Private Stations": [
          "Stations privées"
        ],
        "Privately Owned": [
          "Privé"
        ],
        "Propane": [
          "Propane"
        ],
        "Propane (LPG)": [
          "Propane (GPL)"
        ],
        "Propane (Liquefied Petroleum Gas [LPG])": [
          "Propane (gaz de pétrole liquéfié [GPL])"
        ],
        "Propane (Liquefied Petroleum Gas, LPG) Stations": [
          "Stations de propane (gaz de pétrole liquéfié, ou GPL)"
        ],
        "Propane Nozzles": [
          "Buses de propane"
        ],
        "Propane Nozzles:": [
          "Buses de propane :"
        ],
        "Province/Territory": [
          "Province/territoire"
        ],
        "Provincial Government Owned": [
          "Détenu par le gouvernement provincial"
        ],
        "Public": [
          "Public"
        ],
        "Public Safety and Emergency Preparedness": [
          "Sécurité publique et Protection civile"
        ],
        "Public Services and Procurement": [
          "Services publics et Approvisionnement"
        ],
        "Public Stations": [
          "Stations publiques"
        ],
        "Public locations with the \"primary\" designation must be staffed during regular business hours and must not require drivers to call ahead in order to fuel. Primary stations must also accept credit cards or fleet cards as a payment type. To be considered \"primary,\" the station must be able to fuel vehicles at a rate of 30-45 litres (8-12 gallons) per minute or faster, or at a rate similar to filling a gasoline vehicle.": [
          "Les emplacements publics ayant la désignation « primaire » doivent être dotés en personnel pendant les heures normales de bureau et ne pas obliger les conducteurs à appeler à l’avance pour faire le plein. Par ailleurs, les stations primaires doivent accepter les cartes de crédit ou cartes de parc de véhicules comme type de paiement. Pour être considérée comme « primaire », une station doit être en mesure de ravitailler des véhicules en carburant à un taux de 30 à 45 litres (8 à 12 gallons) par minute ou plus rapidement, ou à un taux semblable à celui du ravitaillement d’un véhicule à essence."
        ],
        "Public locations with the \"primary\" designation must be staffed during regular business hours and must not require drivers to call ahead in order to fuel. Primary stations must also accept credit cards or fleet cards as a payment type. To be considered \"primary,\" the station must be able to fuel vehicles at a rate of 8-12 gallons per minute or faster, or at a rate similar to filling a gasoline vehicle.": [
          "Les emplacements publics avec la désignation « primaire » doivent présenter des employés pendant les heures normales de bureau et ne pas exiger que les conducteurs appellent à l’avance pour obtenir du carburant. Les stations primaires doivent également accepter les cartes de crédit ou cartes de parc de véhicules comme type de paiement. Pour être considérée comme « primaire », une station doit pouvoir ravitailler des véhicules en carburant à un taux de 8 à 12 gallons par minute ou un rythme plus rapide, ou à un taux semblable à celui du ravitaillement d’un véhicule à essence."
        ],
        "Quebec": [
          "Québec"
        ],
        "Quick-connect": [
          "Connexion rapide"
        ],
        "RV Park": [
          "Parc pour caravanes"
        ],
        "Ready Corridor": [
          "Corridor prêt"
        ],
        "Recreational Sports Facility": [
          "Centres de sports récréatifs"
        ],
        "Refinery": [
          "Raffinerie"
        ],
        "Rental Car Return": [
          "Retour du véhicule de location"
        ],
        "Report a Change": [
          "Signaler un changement"
        ],
        "Report a change": [
          "Rapporter un changement"
        ],
        "Required": [
          "Nécessaire"
        ],
        "Required field": [
          "Champ obligatoire"
        ],
        "Research Facility/Laboratory": [
          "Centre de recherche/Laboratoire"
        ],
        "Residential": [
          "Emplacement résidentiel"
        ],
        "Residential EV charging locations and \"wall outlets\" not designated for vehicle charging are not included in the Station Locator, but workplace charging locations are.": [
          "Les emplacements de recharge pour VE résidentielle et les « bornes murales » non désignées pour la recharge des véhicules ne sont pas inclus dans l’outil de recherche des stations, tandis que les emplacements de recharge sur les lieux de travail le sont."
        ],
        "Rest Stop": [
          "Restauroute"
        ],
        "Restaurant": [
          "Restaurant"
        ],
        "Retail": [
          "Vente au détail"
        ],
        "SAE": [
          "SAE"
        ],
        "SAE CCS": [
          "SAE CCS"
        ],
        "SAE Standards Compliance:": [
          "Conformité aux normes SAE :"
        ],
        "Saskatchewan": [
          "Saskatchewan"
        ],
        "School": [
          "École"
        ],
        "Science": [
          "Sciences"
        ],
        "Search": [
          "Rechercher"
        ],
        "Selected Route": [
          "Trajet sélectionné"
        ],
        "Service designations are available in the details page for each public station. The Station Locator defaults to showing only public \"primary\" stations. Users may expand their search to include all propane stations by using the \"Include stations with limited vehicle fueling\" checkbox after choosing propane as a fuel or select this same option in the \"Advanced Filters\" tab.": [
          "Les désignations de services sont disponibles dans la page des détails pour chaque station publique. Par défaut, l’outil de recherche des stations affiche uniquement les stations publiques « principales ». Les utilisateurs peuvent élargir la recherche pour inclure toutes les stations proposant du propane en cochant la case « Inclure les stations avec un ravitaillement limité pour les véhicules », après avoir choisi « Propane » comme carburant. Ils peuvent également sélectionner la même option dans l’onglet « Filtres avancés »."
        ],
        "Service/Gas Station": [
          "Station-service"
        ],
        "Shopping Center": [
          "Centre commercial"
        ],
        "Shopping Mall": [
          "Centre d'achats"
        ],
        "Show stations within": [
          "Montrer les stations dans"
        ],
        "Small Business and Tourism": [
          "Petite entreprise et de Tourisme"
        ],
        "Solar": [
          "Solaire"
        ],
        "Some compressed and liquefied natural gas stations are not able to fuel larger vehicles due to access limitations, such as a low canopy, insufficient parking adjacent to the pump, or limited space to maneuver. Natural gas station details include vehicle accessibility information, specifically the vehicle classes that can physically access the fueling infrastructure. Please note, this field does not take into account station capacity, throughput, or other considerations. Options include:": [
          "Dans certaines stations de gaz naturel comprimé ou liquéfié, il n’est pas possible de ravitailler les gros véhicules en raison de l’accessibilité limitée comme une faible hauteur de dégagement, un espace de stationnement insuffisant près de la pompe ou un espace de manœuvre réduit. Les détails sur les stations de gaz naturel comprennent des données sur l’accessibilité des véhicules, plus précisément les classes de véhicules qui peuvent avoir physiquement accès à l’infrastructure de ravitaillement. Veuillez noter que ce champ ne tient pas compte des capacités de la station, de son débit ou d’autres facteurs. Les options offertes sont les suivantes :"
        ],
        "Source:": [
          "Source :"
        ],
        "Specific Address": [
          "Adresse précise"
        ],
        "Specific station details": [
          "Détails spécifiques de la station"
        ],
        "Stadium": [
          "Stade"
        ],
        "Standalone Station": [
          "Station autonome"
        ],
        "Start location": [
          "point de départ"
        ],
        "State": [
          "État"
        ],
        "State Government Owned": [
          "Détenu par le gouvernement de l’État"
        ],
        "State/Province/Territory": [
          "État/Province/Territoire"
        ],
        "State/Provincial Government": [
          "Gouvernement d'un État ou d'une province"
        ],
        "State/Provincial Government Owned": [
          "Détenu par le gouvernement provincial/de l’État"
        ],
        "State/Territory": [
          "État/Territoire"
        ],
        "Station": [
          "Station"
        ],
        "Station Information": [
          "Renseignements sur la station"
        ],
        "Station Location": [
          "Emplacement de la station"
        ],
        "Station Name": [
          "Nom de la station"
        ],
        "Station Phone": [
          "Numéro de téléphone de la station"
        ],
        "Station Update Schedule": [
          "Calendrier de mise à jour des stations"
        ],
        "Station details are subject to change. We recommend calling the station to verify location, hours of operation, and access.": [
          "Les détails concernant l'emplacement peuvent changer. Nous recommandons d'appeler la station afin de vérifier l'emplacement, les heures d'ouverture et l'accès."
        ],
        "Station status": [
          "Statut de la station"
        ],
        "Stations with an access listing of \"Private - Fleet customers only\" may allow other entities to fuel through a business-to-business arrangement. For more information, fleet customers should refer to the information listed in the details section for that station and contact the station directly.": [
          "Les stations dont l’accès est réservé uniquement aux clients privés ou de parc automobile peuvent permettre à d’autres véhicules de se ravitailler grâce à un arrangement entre entreprises. Pour de plus amples renseignements, les clients de parc automobile devraient consulter les données figurant dans la section des détails relatifs à la station et communiquer directement avec cette dernière."
        ],
        "Status": [
          "Statut"
        ],
        "Status:": [
          "Statut :"
        ],
        "Storage Facility": [
          "Installation de stockage"
        ],
        "Street Parking": [
          "Stationnement sur rue"
        ],
        "Submit": [
          "Soumettre"
        ],
        "Submit New Station": [
          "Proposer une nouvelle station"
        ],
        "TEMPORARILY UNAVAILABLE": [
          "TEMPORAIREMENT SUSPENDU"
        ],
        "Temporarily Unavailable": [
          "Temporairement non disponible"
        ],
        "Tesla": [
          "Tesla"
        ],
        "Thank you for your station submission. Please note that your update will not automatically appear in the Alternative Fueling Station Locator. All station information must be confirmed before changes are made. The turn-around time for updates will depend on the completeness of the information provided as well as the responsiveness of the station or point of contact.": [
          "Merci pour votre soumission. Veuillez prendre note que votre mise à jour n’apparaîtra pas automatiquement dans votre localisateur de stations. Toute l’information sur les stations doit être confirmée avant que les changements soient apportés. Le délai d’exécution des mises à jour varie selon l’exhaustivité des renseignements fournis, de même que la réactivité de la station ou du point de contact."
        ],
        "Thank you for your station submission. Please note that your update will not automatically appear in the Alternative Fueling Station Locator. All station information must be confirmed before changes are made. The turn-around time for updates will depend on the completeness of the information provided as well as the responsiveness of the station or point of contact. We will contact you directly if we have any questions about your submission.": [
          "Merci pour votre soumission. Veuillez prendre note que votre mise à jour n’apparaîtra pas automatiquement dans votre localisateur de stations. Toute l’information sur les stations doit être confirmée avant que les changements soient apportés. Le délai d’exécution des mises à jour varie selon l’exhaustivité des renseignements fournis, de même que la réactivité de la station ou du point de contact. Nous communiquerons directement avec vous pour toute question concernant votre soumission."
        ],
        "The AFDC recommends users verify a station is open, available to the public, and has the desired alternative fuel prior to making a trip to that location.": [
          "L’AFDC recommande aux utilisateurs de vérifier qu’une station est ouverte, accessible au public et qu’elle dispose du carburant de remplacement souhaité avant de s'y rendre."
        ],
        "The Alternative Fueling Station Locator uses the following charging infrastructure definitions:": [
          "Le localisateur de stations de ravitaillement en carburant de remplacement utilise les définitions d’infrastructures de chargement suivantes :"
        ],
        "The Station Locator Team": [
          "L’équipe de Ressources naturelles Canada"
        ],
        "The Station Locator data differentiates between public hydrogen stations that are only available to a certain subset of customers (e.g., require an access card, PIN, or training) and those that are considered retail locations (e.g., accept payment at the point of sale). Access designations are available in the details page for each public station. The Station Locator defaults to showing only public retail stations. Users may expand their search to include all public hydrogen stations by selecting the \"Include non-retail stations\" checkbox.": [
          "Les données de l’outil de recherche des stations font la différence entre les stations publiques proposant de l’hydrogène qui sont uniquement accessibles par un certain type de client (p. ex. obligation de présenter une carte d’accès, un  NIP ou disposer d’une formation particulière) et celles qui sont considérées comme des emplacement de vente au détail (p. ex. qui acceptent le paiement directement au point de vente). Les désignations d’accès sont disponibles dans la page des détails pour chaque station publique. Par défaut, l’outil de recherche des stations affiche uniquement les stations publiques « de vente au détail ». Les utilisateurs peuvent élargir la recherche pour inclure toutes les stations publiques proposant de l’hydrogène en cochant la case « Inclure les stations hors vente au détail »."
        ],
        "The Station Locator defaults to searching only for public stations. To include private stations in the search, use the Station button on the \"Advanced Filters\" tab.": [
          "Par défaut, l’outil de recherche des stations recherche uniquement les stations publiques. Pour inclure les stations privées dans la recherche, utilisez le bouton « Station » dans l’onglet « Filtre avancés »."
        ],
        "The Station Locator imports Blink, ChargePoint, Electrify America, EVgo, FLO, Greenlots, OpConnect, SemaConnect, and Webasto network station data directly from these networks on a daily basis. Please note there may be variations in the formatting of API stations from other alternative fuels in the Station Locator. Also note, NREL cannot edit station information for the networks listed above. To suggest edits to these stations, please contact the charging network directly with the recommended changes. For network contact information, please contact the webmaster listed in the \"More Information\" section below.": [
          "Le Localisateur de stations importe directement des données de stations des réseaux Blink, ChargePoint, Electrify America, EVgo, FLO, Greenlots, OpConnect, SemaConnect et Webasto quotidiennement. Veuillez noter que le format des stations de l’API provenant d’autres carburants de remplacement du Localisateur de stations pourrait varier. De plus, le NREL ne peut pas modifier l’information des stations des réseaux susmentionnés. Pour suggérer des modifications à ces stations, veuillez communiquer les modifications recommandées directement au réseau de recharge. Pour obtenir les coordonnées des réseaux, veuillez communiquer avec le webmestre indiqué dans la section « Plus d’information » ci-dessous."
        ],
        "The Station Locator imports ChargePoint, Circuit électrique, FLO, Greenlots, and SemaConnect network station data directly from these networks on a daily basis. Please note there may be variations in the formatting of API stations from other alternative fuels in the Station Locator. Also note, NRCan cannot edit station information for the networks listed above. To suggest edits to these stations, please contact the charging network directly with the recommended changes. For network contact information, please contact the webmaster listed in the \"More Information\" section below.": [
          "Le Localisateur de stations importe directement des données de stations des réseaux ChargePoint, Circuit électrique, FLO, Greenlots et SemaConnect quotidiennement. Veuillez noter que le format des stations de l’API provenant d’autres carburants de remplacement du Localisateur de stations pourrait varier. De plus, notez que RNCan ne peut pas modifier les renseignements des stations des réseaux indiqués ci-dessus. Pour proposer des modifications à ces stations, veuillez communiquer les modifications recommandées directement au réseau de recharge. Pour obtenir les coordonnées des réseaux, veuillez communiquer avec le webmestre indiqué dans la section « Plus d’information » ci-dessous."
        ],
        "The Station Locator includes information on private fleet fueling stations (e.g., transit bus fueling facilities, other medium- and heavy-duty fueling and charging infrastructure) and workplace charging stations. Note that information on these stations is not always published online or in the data download but may be tracked only in the backend Station Locator database. Information tracked only in the backend database may be provided by request to the webmaster listed in the \"More Information\" section below.": [
          "Le Localisateur de stations contient de l’information sur les stations de ravitaillement de parcs privés (p. ex., installations de ravitaillement d’autobus urbains, autres infrastructures de recharge et de ravitaillement de véhicules de poids moyen et lourd), et les stations de recharge en milieu de travail. Il convient de noter que l’information sur ces stations n’est pas toujours affichée en ligne ou dans le téléchargement des données; il se peut qu’elle soit uniquement accessible dans la banque de données de fond du Localisateur de stations. On peut fournir l’information surveillée uniquement dans la banque de données de fond par le biais d’une demande au webmestre indiqué dans la section « Plus d’information » ci-dessous."
        ],
        "The Station Locator includes information on private fleet fueling stations (e.g., transit bus fueling facilities, other medium- and heavy-duty fueling and charging infrastructure), workplace charging stations, and multi-family housing charging stations. Note that information on these stations is not always published online or in the data download but may be tracked only in the backend Station Locator database. Information tracked only in the backend database may be provided by request to the webmaster listed in the \"More Information\" section below.": [
          "Le Localisateur de stations contient de l’information sur les stations de ravitaillement de parcs privés (p. ex., installations de ravitaillement d’autobus urbains, autres infrastructures de recharge et de ravitaillement de véhicules de poids moyen et lourd), les stations de recharge en milieu de travail et les stations de recharge d’immeubles à plusieurs logements. Il convient de noter que l’information sur ces stations n’est pas toujours affichée en ligne ou dans le téléchargement des données; il se peut qu’elle soit uniquement accessible dans la banque de données de fond du Localisateur de stations. On peut fournir l’information surveillée uniquement dans la banque de données de fond au moyen d’une demande au webmestre indiqué dans la section « Plus d’information » ci-dessous."
        ],
        "The Station Locator includes stations offering high-level ethanol-gasoline blends (E85). Users may limit their search to E85 stations offering mid-level blends, such as E30, by using the Fuel button on the \"Advanced Filters\" tab.": [
          "L’outil de recherche des stations inclut des stations proposant des mélanges éthanol-gasoil de haute qualité (E85). Les utilisateurs peuvent limiter leurs recherches aux stations E85 proposant des mélanges de qualité intermédiaire, comme le E30, en utilisant le bouton « Carburant » dans l’onglet « Filtres avancés »."
        ],
        "The Station Locator only includes stations offering biodiesel blends of 20% (B20) and above for a certain period of time during the year. The available blends at each station location are displayed when the station location is selected.": [
          "L’outil de recherche des stations inclut uniquement les stations proposant des mélanges de biodiesel de 20 % (B20) et supérieur pour une certaine période au cours de l’année. Les mélanges disponibles à chaque station sont affichés lorsque ledit emplacement est sélectionné."
        ],
        "The data in the Alternative Fueling Station Locator are gathered and verified through a variety of methods. National Resources Canada (NRCan) obtains information about new stations from trade media, the Submit New Station form on the Station Locator website, and through collaborating with infrastructure equipment and fuel providers, original equipment manufacturers (OEMs), and industry groups.": [
          "Diverses méthodes sont utilisées pour recueillir et vérifier les données du Localisateur de stations de ravitaillement en carburants de remplacement. Ressources naturelles Canada (RNCan) obtient de l’information sur les nouvelles stations auprès des médias spécialisés, par l’intermédiaire du formulaire « Proposer une nouvelle station » sur le site Web du Localisateur de stations, et aussi en collaborant avec les fournisseurs d’infrastructures et de carburants, les fabricants d’équipement d’origine (FEO) et les groupes industriels."
        ],
        "The data in the Alternative Fueling Station Locator are gathered and verified through a variety of methods. The National Renewable Energy Laboratory (NREL) obtains information about new stations from trade media, Clean Cities coordinators, the Submit New Station form on the Station Locator website, and through collaborating with infrastructure equipment and fuel providers, original equipment manufacturers (OEMs), and industry groups.": [
          "Diverses méthodes sont utilisées pour recueillir et vérifier les données du Localisateur de stations de ravitaillement en carburants de remplacement. Le National Renewable Energy Laboratory (NREL) des États-Unis obtient de l’information sur les nouvelles stations auprès des médias spécialisés, des coordonnateurs des villes propres et par l’intermédiaire du formulaire « Proposer une nouvelle station » sur le site Web du Localisateur de stations, et aussi en collaborant avec les fournisseurs d’infrastructures et de carburants, les fabricants d’équipement d’origine (FEO) et les groupes industriels."
        ],
        "The location could not be found. Please try another location.": [
          "L’emplacement n’a pas pu être trouvé. Veuillez essayer un autre emplacement."
        ],
        "The station could not be found. Please try searching for another station.": [
          "La station n’a pas pu être trouvée. Veuillez essayer de chercher une autre station."
        ],
        "There are no stations along the route that match your filters.": [
          "Aucune station sur le trajet ne correspond à vos filtres."
        ],
        "There are no stations that match your filters.": [
          "Aucune station ne correspond à vos filtres."
        ],
        "There are three types of DC fast charging systems depending on the type of charge port on the vehicle. Provides 60 to 80 miles of range per 20 minutes of charging.": [
          "Il y a trois types de systèmes de recharge DC Fast selon le type de port de recharge sur le véhicule. Fournit de 60 à 80 milles de trajet par 20 minutes de recharge."
        ],
        "There are three types of DC fast charging systems depending on the type of charge port on the vehicle. Provides 95 to 130 kilometers of range per 20 minutes of charging.": [
          "Il y a trois types de systèmes de recharge DC Fast selon le type de port de recharge sur le véhicule. Fournit de 95 à 130 kilomètres de trajet par 20 minutes de recharge."
        ],
        "These stations are only available to a certain subset of customers.": [
          "Ces stations ne sont accessibles qu’à un certain sous-ensemble de clients."
        ],
        "These stations have fuel available for use in vehicles but limited vehicle fueling services.": [
          "Ces stations ont du carburant disponible pour les véhicules, mais des services de ravitaillement en carburant limités."
        ],
        "This field is required.": [
          "Ce champ est nécessaire."
        ],
        "This form cannot be submitted. See the errors marked below.": [
          "Ce formulaire ne peut pas être envoyé. Consulter les erreurs indiquées ci-dessous."
        ],
        "This station has fuel for vehicles and vehicle-specific fueling services that are consistently offered during business hours.": [
          "Cette station offre toujours du carburant et des services de ravitaillement propres à certaines catégories de véhicules pendant les heures d’ouverture."
        ],
        "This station has fuel for vehicles but limited availability and/or limited vehicle-specific fueling capabilities.": [
          "Cette station offre du carburant, mais sa disponibilité est limitée, tout comme les capacités de prestation de services de ravitaillement propres à certaines catégories de véhicules."
        ],
        "This station is available to all customers and is considered a retail location.": [
          "Cette station est accessible à tous les clients et est considérée comme un point de vente au détail."
        ],
        "This station is only available to a certain subset of customers and is considered a non-retail location.": [
          "Cette station n’est accessible qu’à un certain sous-ensemble de clients et est considérée comme un emplacement non destiné à la vente au détail."
        ],
        "Time-fill": [
          "Remplissage minuté"
        ],
        "Transport": [
          "Transports"
        ],
        "Transportation Network Company": [
          "Entreprise responsable du réseau de transport"
        ],
        "Travel Center": [
          "Services de voyage"
        ],
        "Treasury Board": [
          "Conseil du Trésor"
        ],
        "Truck Stop": [
          "Relais routier"
        ],
        "Type": [
          "Type"
        ],
        "Type of Access": [
          "Type d’accès"
        ],
        "Types:": [
          "Types :"
        ],
        "U.S. and Canada": [
          "É.-U. et Canada"
        ],
        "Unavailable": [
          "Non disponible"
        ],
        "United States": [
          "États-Unis"
        ],
        "Unknown": [
          "Inconnu"
        ],
        "Use this form to suggest adding a station.": [
          "Utiliser ce formulaire pour suggérer l’ajout d’une station."
        ],
        "Use this form to suggest updates for the station.": [
          "Utiliser ce formulaire pour suggérer des mises à jour de station."
        ],
        "Users submitting updates through the \"Submit New Station\" or \"Report a Change\" forms will receive an email confirmation of their submittal. NRCan will verify station details before the station is added or updated in the Station Locator. The turnaround time for updates will depend on the completeness of the information provided, as well as the responsiveness of the station or point of contact.": [
          "Les utilisateurs qui soumettent des mises à jour au moyen des formulaires « Proposer une nouvelle station » ou « Signaler un changement » recevront une confirmation de la soumission par courriel. RNCan vérifiera les renseignements de la station avant de les ajouter ou de les mettre à jour dans le Localisateur de stations. Le délai d’exécution pour les mises à jour dépendra de l’exhaustivité des renseignements fournis, ainsi que de la réceptivité de la station ou du point de service."
        ],
        "Users submitting updates through the \"Submit New Station\" or \"Report a Change\" forms will receive an email confirmation of their submittal. NREL will verify station details before the station is added or updated in the Station Locator. The turnaround time for updates will depend on the completeness of the information provided, as well as the responsiveness of the station or point of contact.": [
          "Les utilisateurs qui soumettent des mises à jour au moyen des formulaires « Proposer une nouvelle station » ou « Signaler un changement » recevront une confirmation de la soumission par courriel. Le NREL vérifiera les renseignements de la station avant de les ajouter ou de les mettre à jour dans le Localisateur de stations. Le délai d’exécution pour les mises à jour dépendra de l’exhaustivité des renseignements fournis, ainsi que de la réceptivité de la station ou du point de service."
        ],
        "Utility": [
          "Service public"
        ],
        "Utility Owned": [
          "Détenu par une société de service public"
        ],
        "Vehicle Accessibility:": [
          "Accessibilité des véhicules :"
        ],
        "Vehicle accessibility": [
          "Accessibilité des véhicules"
        ],
        "Veterans Affairs": [
          "Anciens combattants"
        ],
        "Wastewater Treatment": [
          "Traitement des eaux usées"
        ],
        "We will contact you directly if we have any questions about your submission.": [
          "Nous communiquerons directement avec vous pour toute question concernant votre soumission."
        ],
        "What feedback would you like to provide?": [
          "Quels commentaires voudriez-vous fournir?"
        ],
        "Wind": [
          "Vent"
        ],
        "Within %s km of:": [
          "Dans un rayon de %s km autour de :"
        ],
        "Within %s mi of:": [
          "Dans un rayon de %s mi autour de :"
        ],
        "Workplace": [
          "Milieu de travail"
        ],
        "Yes": [
          "Oui"
        ],
        "You can download the station data using:": [
          "Vous pouvez télécharger les données sur les stations en utilisant :"
        ],
        "Your Contact Information": [
          "Vos coordonnées"
        ],
        "Your browser is not compatible with this application. Please update your browser to the latest version or <a href=\"%s\">contact us</a> for assistance.": [
          "Votre navigateur n’est pas compatible avec cette application. Veuillez mettre à jour votre navigateur pour obtenir la dernière version ou <a href=\"%s\">communiquez avec nous</a> pour obtenir de l'aide."
        ],
        "Your search exceeds the maximum distance of 100 miles from the route. Please enter a shorter distance.": [
          "Votre recherche dépasse la distance maximale de 100 milles de l’itinéraire. Veuillez saisir une distance plus courte."
        ],
        "Your search exceeds the maximum distance of 160 kilometers from the route. Please enter a shorter distance.": [
          "Votre recherche dépasse la distance maximale de 160 kilomètres de l’itinéraire. Veuillez saisir une distance plus courte."
        ],
        "Your search exceeds the maximum radius of 500 miles from the location. Please enter a smaller radius.": [
          "Votre recherche dépasse le rayon maximal de 500 milles de l’emplacement. Veuillez saisir un rayon plus petit."
        ],
        "Your search exceeds the maximum radius of 804 kilometers from the location. Please enter a smaller radius.": [
          "Votre recherche dépasse le rayon maximal de 804 kilomètres de l’emplacement. Veuillez saisir un rayon plus petit."
        ],
        "Yukon": [
          "Yukon"
        ],
        "bar": [
          "bar"
        ],
        "clear all filters": [
          "réinitialiser tous les filtres"
        ],
        "for U.S. stations": [
          "pour les stations états-uniennes"
        ],
        "iPhone App": [
          "App iPhone"
        ],
        "km": [
          "km"
        ],
        "miles": [
          "milles"
        ],
        "access|\u0004Private": [
          "Privé"
        ],
        "access|\u0004Public": [
          "Public"
        ],
        "access|\u0004Public & private": [
          "Public et privé"
        ]
      }
    }
  }
};
/* eslint-enable */

//
// DO NOT MANUALLY MODIFY THIS FILE: Regenerate with "rake gettext:po2js"
//
